/* eslint-disable no-restricted-globals */
import { useEffect, useMemo, useRef, useState } from "react";
const SHELL_WG_PN_MAP = {
  // === CITOS 40 · FMVSS 302 (NCS S8000N Dark Gray Cap · Edge profile Citos 30,40) ===
  "C40-F302-LH-AISLE-WG-GRY": "1085067.5642",
  // Holes left side
  "C40-F302-RH-AISLE-WG-GRY": "1085067.5642",
  // Holes left side
  "C40-F302-LH-WALL-WG-GRY": "1085066.5642",
  // Holes right side
  "C40-F302-RH-WALL-WG-GRY": "1085066.5642",
  // Holes right side
  // === CITOS 10 · FMVSS 302 (NCS S8000N Dark Gray Cap · Edge profile Citos 10) ===
  "C10-F302-LH-AISLE-WG-GRY": "1085067.5612",
  // Holes left side
  "C10-F302-RH-AISLE-WG-GRY": "1085067.5612",
  // Holes left side
  "C10-F302-LH-WALL-WG-GRY": "1085066.5612",
  // Holes right side
  "C10-F302-RH-WALL-WG-GRY": "1085066.5612",
  // Holes right side
  // === CITOS 10 · Docket 90A (RAL 1023 Yellow Cap · Edge profile Citos 10) ===
  "C10-D90-LH-AISLE-WG-YEL": "1087002.5312",
  // Holes left side
  "C10-D90-RH-AISLE-WG-YEL": "1087002.5312",
  // Holes left side
  "C10-D90-LH-WALL-WG-YEL": "1087173.5312",
  // Holes right side
  "C10-D90-RH-WALL-WG-YEL": "1087173.5312"
  // Holes right side
};
const SHELL_WOG_PN_MAP = {
  // === CITOS 40 · FMVSS 302 (Edge profile Citos 30,40) ===
  "C40-F302-LH-AISLE-WOG": "194891.5042",
  // Holes left side
  "C40-F302-RH-WALL-WOG": "194891.5042",
  // Holes left side
  "C40-F302-RH-AISLE-WOG": "194890.5042",
  // Holes right side
  "C40-F302-LH-WALL-WOG": "194890.5042",
  // Holes right side
  "C40-F302-SGL-WOG": "147405.5042",
  // Without connector holes (Single seat)
  // === CITOS 10 · FMVSS 302 (Edge profile Citos 10) ===
  "C10-F302-LH-AISLE-WOG": "194891.5012",
  // Holes left side
  "C10-F302-RH-WALL-WOG": "194891.5012",
  // Holes left side
  "C10-F302-RH-AISLE-WOG": "194890.5012",
  // Holes right side
  "C10-F302-LH-WALL-WOG": "194890.5012",
  // Holes right side
  "C10-F302-SGL-WOG": "147405.5012",
  // Without connector holes (Single seat)
  "C10-F302-MID-WOG": "194894.5012",
  // Holes both sides (Middle seat)
  // === CITOS 10 · Docket 90A (Doc 90 · Edge profile Citos 10) ===
  "C10-D90-LH-AISLE-WOG": "1087004.5012",
  // Holes left side
  "C10-D90-RH-WALL-WOG": "1087004.5012",
  // Holes left side
  "C10-D90-RH-AISLE-WOG": "1087003.5012",
  // Holes right side
  "C10-D90-LH-WALL-WOG": "1087003.5012",
  // Holes right side
  "C10-D90-SGL-WOG": "1087000.5012",
  // Without connector holes (Single seat)
  "C10-D90-MID-WOG": "1087005.5012"
  // Holes both sides (Middle seat)
};
const CITOS_10_INSERT_REFERENCE_TABLES = {
  SR_5087_DOCKET_90A_DARK_GREY: [
    { item: 1, config: "512084", pn: "525897", description: "Backrest Insert CITOS 10 STD SEAT" },
    { item: 2, config: "512086", pn: "525898", description: "Seat Cushion Insert CITOS 10 (450mm width) STD SEAT" },
    { item: 3, config: "513632", pn: "525899.5", description: "Backrest Insert for CITOS 10 FLIP SEAT" },
    { item: 4, config: "513634", pn: "525900.5", description: "Seat Inserts for CITOS 10 (450mm width) FLIP SEAT" },
    { item: 5, config: "180669", pn: "525901.5", description: "Seat Insert for CITOS 10 (420mm width) FLIP SEAT CENTER" },
    { item: 6, config: "178276", pn: "525902.5", description: "Seat Insert for CITOS 10 (420mm width) FLIP SEAT LH" },
    { item: 7, config: "178285", pn: "525903.5", description: "Seat Insert for CITOS 10 (420mm width) FLIP SEAT RH" }
  ],
  SR_3178_PORT_AUTHORITY_RAL_5007_BLUE: [
    { item: 1, config: "512084", pn: "512253", description: "Backrest Insert CITOS 10 STD SEAT" },
    { item: 2, config: "512086", pn: "512247", description: "Seat Cushion Insert CITOS 10 (450mm width) STD SEAT" },
    { item: 3, config: "513632", pn: "513632.3", description: "Backrest Insert for CITOS 10 FLIP SEAT" },
    { item: 4, config: "513634", pn: "513634.3", description: "Seat Inserts for CITOS 10 (450mm width) FLIP SEAT" },
    { item: 5, config: "180669", pn: "180669.3", description: "Seat Insert for CITOS 10 (420mm width) FLIP SEAT CENTER" },
    { item: 6, config: "178276", pn: "178276.3", description: "Seat Insert for CITOS 10 (420mm width) FLIP SEAT LH" },
    { item: 7, config: "178285", pn: "178285.3", description: "Seat Insert for CITOS 10 (420mm width) FLIP SEAT RH" }
  ]
};
const CITOS_40_FOAM_REFERENCE_TABLE = [
  { pn: "511480", description: "FOAM 10mm BACKREST CITOS 40", imperial: '3/8" / 1/2" Back', application: "Standard Citos 40 Backrest" },
  { pn: "519589", description: "FOAM, SEAT 15mm CITOS 40 450", imperial: '1/2" Bottom', application: "Standard 450mm Seat Cushion" },
  { pn: "511478", description: "FOAM, SEAT 15mm CITOS 40 420", imperial: '1/2" Bottom', application: "Standard 420mm Seat Cushion" },
  { pn: "161318", description: "FOAM, BACK 10mm CITOS F/U 40", imperial: '3/8" Back', application: "Flip-Up Citos 40 Backrest" },
  { pn: "511479", description: "FOAM 15mm SEAT CUSHION CITOS 4", imperial: '1/2" Bottom', application: "Citos 4 Seat Cushion" }
];
const C40_BACKREST_VARIANTS = {
  NJT: {
    key: "NJT",
    title: "NJT (Morbern Navy)",
    badge: "NJT SPEC",
    trim: "Morbern Mor-Care Bayfield BA362 Navy",
    foamSpec: '1/2" Padded Poly',
    foamPn: "511480",
    seatFoamSpec: '1/2" Bottom',
    seatFoamPn: "519589",
    pn: "514375.004",
    seatPn: "514376.004",
    image: "/renders/insert/C40NJTBackrest.png",
    seatImage: "/renders/insert/C40NJTseat.png",
    description: 'Citos 40 ergonomic upholstered backrest cushion in Morbern Mor-Care Bayfield BA362 Navy transit vinyl with 1/2" padded poly.'
  },
  Olympia: {
    key: "Olympia",
    title: "Olympia (Momentum Silica)",
    badge: "OLYMPIA SPEC",
    trim: "Momentum Vinyl Silica Scout Vast",
    foamSpec: '3/8" Back Foam',
    foamPn: "511480",
    seatFoamSpec: '1/2" Bottom',
    seatFoamPn: "519589",
    pn: "514375.005",
    seatPn: "514376.005",
    image: "/renders/insert/C40OlympiaBackrest.png",
    seatImage: "/renders/insert/C40OlympiaSeat.png",
    description: 'Citos 40 ergonomic upholstered backrest cushion in Momentum Vinyl Silica Scout Vast commercial upholstery with 3/8" backrest foam.'
  }
};
const C10_BACKREST_VARIANTS = {
  "Dark Gray": {
    key: "Dark Gray",
    title: "Dark Grey (Docket 90A)",
    badge: "DOCKET 90A",
    standard: "Docket 90A",
    colorCode: "NCS S 8000-N Dark Grey",
    pn: "525897",
    seatPn: "525898",
    bomRef: "512084",
    image: "/renders/insert/C1darkgrayBackrest.png",
    seatImage: "/renders/insert/C10grayseat.png",
    description: "Citos 10 ergonomic molded backrest insert in NCS S 8000-N Dark Grey, compliant with Docket 90A standard."
  },
  Blue: {
    key: "Blue",
    title: "Blue (FMVSS 302)",
    badge: "FMVSS 302",
    standard: "FMVSS 302",
    colorCode: "RAL 5007 Blue",
    pn: "512253",
    seatPn: "512247",
    bomRef: "512084",
    image: "/renders/insert/C10blueBackrest.png",
    seatImage: "/renders/insert/C10blueseat.png",
    description: "Citos 10 ergonomic molded backrest insert in RAL 5007 Blue (Port Authority SR-3178 spec), compliant with FMVSS 302 standard."
  }
};
const C40_SEAT_VARIANTS = {
  NJT: {
    key: "NJT",
    title: "NJT (Morbern Navy)",
    badge: "NJT SPEC",
    trim: "Morbern Mor-Care Bayfield BA362 Navy",
    foamSpec: '1/2" Bottom',
    foamPn: "519589",
    pn: "514376.004",
    image: "/renders/insert/C40NJTseat.png",
    description: 'Citos 40 replaceable upholstered ergonomic seat cushion assembly in Morbern Mor-Care Bayfield BA362 Navy transit vinyl with 1/2" bottom foam.'
  },
  Olympia: {
    key: "Olympia",
    title: "Olympia (Momentum Silica)",
    badge: "OLYMPIA SPEC",
    trim: "Momentum Vinyl Silica Scout Vast",
    foamSpec: '1/2" Bottom',
    foamPn: "519589",
    pn: "514376.005",
    image: "/renders/insert/C40OlympiaSeat.png",
    description: 'Citos 40 replaceable upholstered ergonomic seat cushion assembly in Momentum Vinyl Silica Scout Vast commercial upholstery with 1/2" bottom foam.'
  }
};
const C10_SEAT_VARIANTS = {
  "Dark Gray": {
    key: "Dark Gray",
    title: "Dark Grey (Docket 90A)",
    badge: "DOCKET 90A",
    standard: "Docket 90A",
    colorCode: "NCS S 8000-N Dark Grey",
    pn: "525898",
    bomRef: "512086",
    image: "/renders/insert/C10grayseat.png",
    description: "Citos 10 ergonomic molded seat cushion insert in NCS S 8000-N Dark Grey, compliant with Docket 90A standard."
  },
  Blue: {
    key: "Blue",
    title: "Blue (FMVSS 302)",
    badge: "FMVSS 302",
    standard: "FMVSS 302",
    colorCode: "RAL 5007 Blue",
    pn: "512247",
    bomRef: "512086",
    image: "/renders/insert/C10blueseat.png",
    description: "Citos 10 ergonomic molded seat cushion insert in RAL 5007 Blue (Port Authority SR-3178 spec), compliant with FMVSS 302 standard."
  }
};
const SPACER_VARIANTS = {
  "FMVSS 302": {
    key: "FMVSS 302",
    standard: "FMVSS 302",
    pn: "511965",
    title: "Spacer Citos 450 (FMVSS 302)",
    colorCode: "RAL NCS S 6000-N",
    description: "Spacer Citos 450 in RAL NCS S 6000-N (Standard transit specification, FMVSS 302 compliant)."
  },
  "Doc 90": {
    key: "Doc 90",
    standard: "Doc 90",
    pn: "524627",
    title: "Spacer Citos 450 (Doc 90)",
    colorCode: "Docket 90A",
    description: "Spacer Citos 450 compliant with Docket 90A fire safety standard."
  }
};
const T_PEDESTAL_CONFIGS = {
  single: {
    key: "single",
    label: "Single Cap (1x Cover)",
    title: "T-Pedestal Plastic Cap (Single Unit)",
    capQty: 1,
    pn: "519162",
    description: "T-Pedestal plastic cover (BLACK) \u2014 Single replacement unit.",
    fasteners: [
      { id: 101, pn: "302774", description: "Self-drilling screw 4,8x16 DIN 7504M (KIEL NA)", qty: 4 },
      { id: 102, pn: "170339", description: "T-Pedestal square washer (SST.)", qty: 1 }
    ]
  },
  pedestal: {
    key: "pedestal",
    label: "Full Pedestal (1 Foot / 2x Caps)",
    title: "T-Pedestal Cap Set (Full 1-Foot Assembly)",
    capQty: 2,
    pn: "519162",
    description: "T-Pedestal plastic cover set for 1 complete pedestal foot (2x black caps, front & rear).",
    fasteners: [
      { id: 101, pn: "302774", description: "Self-drilling screw 4,8x16 DIN 7504M (KIEL NA)", qty: 8 },
      { id: 102, pn: "170339", description: "T-Pedestal square washer (SST.)", qty: 2 }
    ]
  }
};
const SPACER_FASTENERS_BOM = [
  { id: 106, pn: "4000031", description: "Sap Bolt M6x60 DIN 6912", qty: 1 },
  { id: 107, pn: "302335", description: "Sap Bolt M6x90 DIN 6912", qty: 1 },
  { id: 108, pn: "3008395", description: "Washer A6.4 DIN 9021-ST", qty: 4 },
  { id: 109, pn: "3008371", description: "Nylon Nut M985", qty: 2 }
];
const SHELL_FASTENERS_BOM = [
  { id: 103, pn: "1041450", description: "T-bolt M8x30 (zinc plated)", spec: "M8x30", qty: 4 },
  { id: 104, pn: "3008041", description: "Washer A8.4 DIN 9021-ST (zinc plated)", spec: "DIN 9021-ST", qty: 4 },
  { id: 105, pn: "3009200", description: "Flange locking nut M8 DIN 6923 (zinc plated)", spec: "DIN 6923", qty: 4 }
];
const USB_FASTENERS_BOM = [
  { id: 110, pn: "302268", description: "Socket cap bolt M4x12 DIN 912", spec: "M4x12 DIN 912", qty: 2 },
  { id: 111, pn: "302458", description: "Dome cap nut M4 DIN 986", spec: "M4 DIN 986", qty: 2 }
];
const RUBBER_FASTENERS_BOM = [
  { id: 112, pn: "3008879", description: "PT Screw 4x12 (WN 1411)", spec: "4x12 WN 1411", qty: 1 }
];
const ALL_HARDWARE_ITEMS = {
  101: { id: 101, name: "Self-drilling screw 4,8x16 DIN 7504M", group: "Fasteners", description: "T-Pedestal self-drilling screw 4,8x16 (DIN 7504M \xB7 KIEL NA)", pn: "302774", customerNumber: "" },
  102: { id: 102, name: "T-Pedestal square washer (SST.)", group: "Fasteners", description: "Stainless steel square alignment washer for T-Pedestal mounting", pn: "170339", customerNumber: "" },
  103: { id: 103, name: "T-bolt M8x30 (zinc plated)", group: "Fasteners", description: "Seat shell frame mounting T-bolt M8x30 (zinc plated)", pn: "1041450", customerNumber: "" },
  104: { id: 104, name: "Washer A8.4 DIN 9021-ST", group: "Fasteners", description: "Zinc plated washer A8.4 for seat shell mounting", pn: "3008041", customerNumber: "" },
  105: { id: 105, name: "Flange locking nut M8 DIN 6923", group: "Fasteners", description: "Zinc plated flange locking nut M8 for seat shell mounting", pn: "3009200", customerNumber: "" },
  106: { id: 106, name: "Sap Bolt M6x60 DIN 6912", group: "Fasteners", description: "Socket head cap screw M6x60 DIN 6912 for seat spacer", pn: "4000031", customerNumber: "" },
  107: { id: 107, name: "Sap Bolt M6x90 DIN 6912", group: "Fasteners", description: "Socket head cap screw M6x90 DIN 6912 for seat spacer", pn: "302335", customerNumber: "" },
  108: { id: 108, name: "Washer A6.4 DIN 9021-ST", group: "Fasteners", description: "Washer A6.4 DIN 9021-ST for seat spacer", pn: "3008395", customerNumber: "" },
  109: { id: 109, name: "Nylon Nut M985", group: "Fasteners", description: "Nylon insert lock nut M6 DIN 985 for seat spacer", pn: "3008371", customerNumber: "" },
  110: { id: 110, name: "Socket cap bolt M4x12 DIN 912", group: "Fasteners", description: "Socket head cap bolt M4x12 DIN 912 for USB module enclosure (Pos. 510)", pn: "302268", customerNumber: "" },
  111: { id: 111, name: "Dome cap nut M4 DIN 986", group: "Fasteners", description: "Dome cap nut M4 DIN 986 for USB module enclosure (Pos. 520)", pn: "302458", customerNumber: "" },
  112: { id: 112, name: "PT Screw 4x12 (WN 1411)", group: "Fasteners", description: "Self-tapping PT screw 4x12 (WN 1411) for rubber bumper mounting (Pos. 150)", pn: "3008879", customerNumber: "" }
};
const GRABRAIL_CAP_VARIANTS = {
  "Dark Gray": {
    key: "Dark Gray",
    title: "Dark Gray (NCS S 8000-N)",
    colorCode: "NCS S 8000-N",
    standard: "FMVSS 302 / Transit standard",
    image: "/renders/accessories/GRCapGray.png",
    pn: "Pending release",
    description: "Grabrail replacement end cap in NCS S 8000-N Dark Gray."
  },
  Yellow: {
    key: "Yellow",
    title: "Yellow (RAL 1023 \xB7 Doc 90)",
    colorCode: "RAL 1023 (Doc 90)",
    standard: "Docket 90A Compliant",
    image: "/renders/accessories/GRCapYellow.png",
    pn: "524626",
    description: "Cover handle RAL 1023 Citos DOCKET 90"
  }
};
const STANCHION_CUP_VARIANTS = {
  LH: {
    key: "LH",
    title: "LH \xB7 Left Hand",
    pn: "169716",
    image: "/renders/accessories/StanchionCupLH.png",
    auxImage: "/renders/accessories/Stanchion-LH-Aux.png",
    description: 'Stanchion tube mounting cup assembly \u2014 Left Hand (LH). Offset: MAX 150 (5.90").',
    offset: 'MAX 150 (5.90")'
  },
  RH: {
    key: "RH",
    title: "RH \xB7 Right Hand",
    pn: "169715",
    image: "/renders/accessories/StanchionCupRH.png",
    auxImage: "/renders/accessories/Stanchion-RH-Aux.png",
    description: 'Stanchion tube mounting cup assembly \u2014 Right Hand (RH). Offset: MAX 150 (5.90").',
    offset: 'MAX 150 (5.90")'
  }
};
const ARMREST_VARIANTS = {
  LH: {
    key: "LH",
    seatLabel: "Left Seat (LH)",
    armrestType: "Right Hand Armrest (RH)",
    pn: "184139",
    mountingSide: "Right / Aisle Side",
    image: "/renders/accessories/armrest.png",
    diagramImage: "/renders/accessories/SingleSeat.png",
    title: "RH Armrest \xB7 For Left Seat (LH)",
    description: "Regular longitudinal stainless steel armrest assembly with closeout panel \u2014 Right Hand (RH) armrest for Left Seat aisle side."
  },
  RH: {
    key: "RH",
    seatLabel: "Right Seat (RH)",
    armrestType: "Left Hand Armrest (LH)",
    pn: "184138",
    mountingSide: "Left / Aisle Side",
    image: "/renders/accessories/armrest.png",
    diagramImage: "/renders/accessories/SingleSeat.png",
    title: "LH Armrest \xB7 For Right Seat (RH)",
    description: "Regular longitudinal stainless steel armrest assembly with closeout panel \u2014 Left Hand (LH) armrest for Right Seat aisle side."
  }
};
const parts = [
  { id: 1, name: "Seat shell with grabrail", group: "Shell", description: "Standard seat shell component with integrated grabrail", pn: "", customerNumber: "" },
  { id: 2, name: "Seat shell w/o grabrail", group: "Shell", description: "Standard seat shell component without grabrail", pn: "", customerNumber: "" },
  { id: 3, name: "Citos 40 Upholstered Backrest", group: "Upholstery", description: "Replaceable upholstered ergonomic backrest for Citos 40", pn: "514375.004", customerNumber: "" },
  { id: 4, name: "Citos 40 Upholstered Seat", group: "Upholstery", description: "Replaceable upholstered seat cushion for Citos 40", pn: "514376.004", customerNumber: "" },
  { id: 5, name: "Citos 10 Backrest Insert", group: "Inserts", description: "Ergonomic molded backrest insert for Citos 10", pn: "525897", customerNumber: "512084" },
  { id: 6, name: "Citos 10 Seat Insert", group: "Inserts", description: "Ergonomic molded seat insert for Citos 10 (standard width)", pn: "525898", customerNumber: "512086" },
  { id: 7, name: "Spacer", group: "Spacer & GR Caps", description: "Seat spacing and alignment shim component (450mm width)", pn: "511965", customerNumber: "" },
  { id: 8, name: "Grabrail cap", group: "Spacer & GR Caps", description: "Replacement end cap (RAL 1023 Yellow / NCS S 8000-N Dark Gray)", pn: "524626", customerNumber: "" },
  { id: 11, name: "Stanchion cup", group: "Accessories", description: "Stanchion mounting cup and tube integration assembly (LH 169716 / RH 169715)", pn: "169716", customerNumber: "" },
  { id: 9, name: "Armrest assembly", group: "Accessories", description: "Regular longitudinal stainless steel armrest assembly with closeout panel (LH 184138 / RH 184139)", pn: "184139", customerNumber: "" },
  { id: 12, name: "T-Pedestal plastic cap", group: "Accessories", description: "T-Pedestal base plastic protective cover (BLACK \xB7 Universal Transit Standard)", pn: "519162", customerNumber: "" },
  { id: 10, name: "Dual USB Type-A/C charging module", group: "Accessories", description: "Passenger dual USB Type-A & Type-C transit charging module enclosure with integrated 60mm pigtail cable and MOLEX 3901-3023 connector", pn: "522898", customerNumber: "" },
  { id: 13, name: "Aluminum profile cap", group: "Accessories", description: "Extruded aluminum frame profile end cap and edge finisher (BLACK)", pn: "", customerNumber: "" },
  { id: 14, name: "Rubber bumper (1744 75 SHORE)", group: "Accessories", description: "Vibration damping rubber bumper / protective stop \u2014 Pos. 140", pn: "506691", customerNumber: "Pos. 140" }
];
const groups = ["All parts", ...Array.from(new Set(parts.map((part) => part.group)))];
function Placeholder({ compact = false }) {
  return <div className={compact ? "placeholder compact" : "placeholder"} aria-label="Image coming soon"><span className="placeholderMark">+</span><span>Image coming soon</span></div>;
}
const navigation = {
  home: {
    eyebrow: "KIEL AMERICAS \xB7 OFFICIAL DIGITAL CATALOG",
    title: "Genuine Seating Spare Parts & Order Portal",
    copy: "Official digital spare parts catalog and order request portal for Kiel Americas transit seating. Select your vehicle platform and seat family to configure components, verify certified Kiel Part Numbers (PN), and generate request orders with complete fastener BOMs.",
    cards: [
      { title: "City Bus", copy: "Citos modular city bus passenger seating, shells, upholstery & hardware", active: true, next: "city-bus", tag: "Explore" },
      { title: "Coach", copy: "Intercity and motorcoach passenger seating spare parts", active: false, tag: "Coming soon" },
      { title: "Train", copy: "Passenger rail and light rail seating spare parts", active: false, tag: "Coming soon" }
    ]
  },
  "city-bus": { eyebrow: "CITY BUS", title: "Choose a seat family.", copy: "Select the installed Kiel city bus seat to continue to its spare parts structure.", cards: [
    { title: "Citos", copy: "Modular city bus seating system (Citos 10 / Citos 40)", active: true, next: "citos", tag: "Explore" },
    { title: "Esos", copy: "City bus seating system", active: false, tag: "Coming soon" }
  ] },
  citos: { eyebrow: "CITY BUS \xB7 CITOS", title: "Choose a Citos category.", copy: "Continue with the seat or interior component category installed in the vehicle.", cards: [
    { title: "Standard Seats", copy: "Fixed passenger seating, shells, inserts, upholstery, and mounting assemblies", active: true, next: "standard-seats", tag: "Open catalog" },
    { title: "Flip-Up Seats", copy: "Space-saving folding passenger seats", active: false, tag: "Coming soon" },
    { title: "Barriers", copy: "Passenger protection and partition components", active: false, tag: "Coming soon" }
  ] }
};
const RENDER_SLIDES = [
  {
    id: "c10-gray",
    model: "Citos 10",
    colorKey: "Gray",
    colorName: "Dark Gray",
    colorHex: "#383d44",
    image: "/renders/c10-std-gray-seat-iso-wobg.png",
    label: "Citos 10 \xB7 Dark Gray"
  },
  {
    id: "c10-blue",
    model: "Citos 10",
    colorKey: "Blue",
    colorName: "Kiel Blue",
    colorHex: "#1658a5",
    image: "/renders/c10-std-blue-seat-iso-wobg.png",
    label: "Citos 10 \xB7 Kiel Blue"
  },
  {
    id: "c40-gray",
    model: "Citos 40",
    colorKey: "Gray",
    colorName: "Dark Gray",
    colorHex: "#383d44",
    image: "/renders/c40-std-seat-iso-wobg.png",
    label: "Citos 40 \xB7 Dark Gray"
  }
];
function Home() {
  const [view, setView] = useState("home");
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const searchRef = useRef(null);
  const [query, setQuery] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [group, setGroup] = useState("All parts");
  const [cartLines, setCartLines] = useState({});
  const [shellModel, setShellModel] = useState("Citos 10");
  const [shellStandard, setShellStandard] = useState("FMVSS 302");
  const [capColor, setCapColor] = useState("Dark Gray");
  const [seatPosition, setSeatPosition] = useState("Left seat");
  const [vehicleSide, setVehicleSide] = useState("Aisle side");
  const [shellModelWog, setShellModelWog] = useState("Citos 10");
  const [shellStandardWog, setShellStandardWog] = useState("FMVSS 302");
  const [seatPositionWog, setSeatPositionWog] = useState("Left seat");
  const [vehicleSideWog, setVehicleSideWog] = useState("Aisle side");
  const [c40BackrestVariant, setC40BackrestVariant] = useState("NJT");
  const [c10BackrestVariant, setC10BackrestVariant] = useState("Dark Gray");
  const [c40SeatVariant, setC40SeatVariant] = useState("NJT");
  const [c10SeatVariant, setC10SeatVariant] = useState("Dark Gray");
  const [spacerStandard, setSpacerStandard] = useState("FMVSS 302");
  const [grabrailCapVariant, setGrabrailCapVariant] = useState("Dark Gray");
  const [stanchionSide, setStanchionSide] = useState("LH");
  const [stanchionViewMode, setStanchionViewMode] = useState("3d");
  const [armrestSeatSide, setArmrestSeatSide] = useState("LH");
  const [armrestViewMode, setArmrestViewMode] = useState("3d");
  const [tPedestalConfig, setTPedestalConfig] = useState("single");
  const [fastenerModalPartId, setFastenerModalPartId] = useState(null);
  const [usbSpecOpen, setUsbSpecOpen] = useState(false);
  const [includeHardware, setIncludeHardware] = useState({});
  const toggleHardware = (partId) => {
    setIncludeHardware((prev) => ({
      ...prev,
      [partId]: !prev[partId]
    }));
  };
  useEffect(() => {
    if (shellStandard === "FMVSS 302" && capColor === "Yellow") {
      setCapColor("Dark Gray");
    } else if (shellStandard === "Doc 90" && capColor === "Dark Gray") {
      setCapColor("Yellow");
    }
  }, [shellStandard, capColor]);
  useEffect(() => {
    if (shellModel === "Citos 40" && shellStandard === "Doc 90") {
      setShellStandard("FMVSS 302");
      setCapColor("Dark Gray");
    }
  }, [shellModel, shellStandard]);
  useEffect(() => {
    if (shellModelWog === "Citos 40" && shellStandardWog === "Doc 90") {
      setShellStandardWog("FMVSS 302");
    }
  }, [shellModelWog, shellStandardWog]);
  const isVehicleSideDisabled = seatPositionWog === "Middle seat" || seatPositionWog === "Single seat";
  const [cartOpen, setCartOpen] = useState(false);
  const documentType = "Spare Parts Request";
  const currentSlide = RENDER_SLIDES[activeSlideIndex] ?? RENDER_SLIDES[0];
  const seatModel = currentSlide.model;
  useEffect(() => {
    const updateViewFromHash = () => {
      const hash = window.location.hash.replace(/^#\/?/, "");
      if (hash && ["home", "city-bus", "citos", "standard-seats"].includes(hash)) {
        setView(hash);
      }
    };
    updateViewFromHash();
    window.addEventListener("hashchange", updateViewFromHash);
    return () => window.removeEventListener("hashchange", updateViewFromHash);
  }, []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setActiveSlideIndex((prev) => (prev + 1) % RENDER_SLIDES.length);
    }, 3e3);
    return () => clearInterval(interval);
  }, [isPaused]);
  useEffect(() => {
    const focusSearch = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        searchRef.current?.focus();
      }
    };
    window.addEventListener("keydown", focusSearch);
    return () => window.removeEventListener("keydown", focusSearch);
  }, []);
  const rankedParts = useMemo(() => {
    const needle = query.trim().toLowerCase();
    const tokens = needle.split(/\s+/).filter(Boolean);
    if (!tokens.length) return parts;
    return parts.map((part) => {
      const name = part.name.toLowerCase();
      const searchable = `${part.name} ${part.group} ${part.description} ${part.pn} ${part.customerNumber}`.toLowerCase();
      if (!tokens.every((token) => searchable.includes(token))) return null;
      const score = name === needle ? 100 : name.startsWith(needle) ? 60 : name.includes(needle) ? 35 : tokens.reduce((total, token) => total + (name.includes(token) ? 10 : 2), 0);
      return { part, score };
    }).filter((result) => result !== null).sort((a, b) => b.score - a.score).map((result) => result.part);
  }, [query]);
  const visibleParts = useMemo(() => {
    return rankedParts.filter((part) => group === "All parts" || part.group === group);
  }, [group, rankedParts]);
  const chooseSuggestion = (part) => {
    setQuery(part.name);
    setGroup("All parts");
    setSearchOpen(false);
    window.setTimeout(() => document.querySelector("#parts")?.scrollIntoView({ behavior: "smooth" }), 0);
  };
  const cartItemsList = useMemo(() => Object.values(cartLines), [cartLines]);
  const itemCount = useMemo(
    () => cartItemsList.reduce((total, item) => total + item.quantity, 0),
    [cartItemsList]
  );
  const changeQuantity = (lineId, quantity) => {
    setCartLines((current) => {
      const next = { ...current };
      if (quantity <= 0) {
        delete next[lineId];
      } else if (next[lineId]) {
        next[lineId] = { ...next[lineId], quantity };
      }
      return next;
    });
  };
  const addCartLine = (item, qty = 1) => {
    setCartLines((current) => {
      const existing = current[item.lineId];
      if (existing) {
        return {
          ...current,
          [item.lineId]: {
            ...existing,
            quantity: existing.quantity + qty
          }
        };
      }
      return {
        ...current,
        [item.lineId]: {
          ...item,
          quantity: qty
        }
      };
    });
    setCartOpen(true);
  };
  const shellConfigurationCode = useMemo(() => {
    const modelCode = shellModel === "Citos 10" ? "C10" : "C40";
    const stdCode = shellStandard === "FMVSS 302" ? "F302" : "D90";
    const posCode = seatPosition === "Left seat" ? "LH" : "RH";
    const sideCode = vehicleSide === "Aisle side" ? "AISLE" : "WALL";
    const capCode = capColor === "Yellow" ? "YEL" : "GRY";
    return `${modelCode}-${stdCode}-${posCode}-${sideCode}-WG-${capCode}`;
  }, [shellModel, shellStandard, seatPosition, vehicleSide, capColor]);
  const shellDescription = useMemo(() => {
    const modelText = shellModel;
    const stdText = shellStandard === "FMVSS 302" ? "FMVSS 302" : "Docket 90A";
    const shellColor = "Shell NCS S 6000-N";
    const handleCover = capColor === "Yellow" ? "Upper handle cover RAL 1023 (Yellow)" : "Upper handle cover NCS S 8000-N (Dark Gray)";
    const logoInsert = "Insert without logo (Pos.60)";
    const edgeProfile = shellModel === "Citos 40" ? "Edge profile Citos 30,40" : "Edge profile Citos 10";
    const holesText = vehicleSide === "Aisle side" ? "Holes for seat connector left side" : "Holes for seat connector right side";
    return `${modelText} Seat Shell with Grabrail \xB7 ${stdText} \xB7 ${seatPosition} (${vehicleSide}) \xB7 ${shellColor} \xB7 ${handleCover} \xB7 ${logoInsert} \xB7 ${edgeProfile} \xB7 ${holesText}`;
  }, [shellModel, shellStandard, seatPosition, vehicleSide, capColor]);
  const shellWogConfigurationCode = useMemo(() => {
    const modelCode = shellModelWog === "Citos 10" ? "C10" : "C40";
    const stdCode = shellStandardWog === "FMVSS 302" ? "F302" : "D90";
    if (seatPositionWog === "Middle seat") {
      return `${modelCode}-${stdCode}-MID-WOG`;
    }
    if (seatPositionWog === "Single seat") {
      return `${modelCode}-${stdCode}-SGL-WOG`;
    }
    const posCode = seatPositionWog === "Left seat" ? "LH" : "RH";
    const sideCode = vehicleSideWog === "Aisle side" ? "AISLE" : "WALL";
    return `${modelCode}-${stdCode}-${posCode}-${sideCode}-WOG`;
  }, [shellModelWog, shellStandardWog, seatPositionWog, vehicleSideWog]);
  const shellWogDescription = useMemo(() => {
    const modelText = shellModelWog;
    const stdText = shellStandardWog === "FMVSS 302" ? "FMVSS 302" : "Docket 90A";
    const shellColor = "Shell NCS S 6000-N";
    const logoInsert = "Insert without logo (Pos.50)";
    const edgeProfile = shellModelWog === "Citos 40" ? "Edge profile Citos 30,40" : "Edge profile Citos 10";
    let posText = `${seatPositionWog} (${vehicleSideWog})`;
    let holesText = vehicleSideWog === "Aisle side" ? "Holes for seat connector right side" : "Holes for seat connector left side";
    if (seatPositionWog === "Single seat") {
      posText = "Single seat";
      holesText = "Without connector holes";
    } else if (seatPositionWog === "Middle seat") {
      posText = "Middle seat";
      holesText = "Holes for seat connector both sides";
    }
    return `${modelText} Seat Shell w/o Grabrail \xB7 ${stdText} \xB7 ${posText} \xB7 ${shellColor} \xB7 ${logoInsert} \xB7 ${edgeProfile} \xB7 ${holesText}`;
  }, [shellModelWog, shellStandardWog, seatPositionWog, vehicleSideWog]);
  const shellPn = useMemo(() => {
    return SHELL_WG_PN_MAP[shellConfigurationCode] || "";
  }, [shellConfigurationCode]);
  const shellWogPn = useMemo(() => {
    return SHELL_WOG_PN_MAP[shellWogConfigurationCode] || "";
  }, [shellWogConfigurationCode]);
  const shellAuxImage = useMemo(() => {
    const isLeft = seatPosition === "Left seat";
    const isAisle = vehicleSide === "Aisle side";
    if (isLeft) {
      return isAisle ? { src: "/renders/shell-supview/LH-AisleSide.png", title: "LH \xB7 Aisle Side", code: "LH-A" } : { src: "/renders/shell-supview/LH-WallSide.png", title: "LH \xB7 Wall Side", code: "LH-W" };
    } else {
      return isAisle ? { src: "/renders/shell-supview/RH-Aisle Side.png", title: "RH \xB7 Aisle Side", code: "RH-A" } : { src: "/renders/shell-supview/RH-Wall Side.png", title: "RH \xB7 Wall Side", code: "RH-W" };
    }
  }, [seatPosition, vehicleSide]);
  const shellWogAuxImage = useMemo(() => {
    if (seatPositionWog === "Middle seat") {
      return { src: "/renders/shell-supview/MidwoGR.png", title: "Middle Seat", code: "MID", isPlaceholder: false };
    }
    if (seatPositionWog === "Single seat") {
      return { src: "/renders/shell-supview/SinglewoGR.png", title: "Single Seat", code: "SGL", isPlaceholder: false };
    }
    const isLeft = seatPositionWog === "Left seat";
    const isAisle = vehicleSideWog === "Aisle side";
    if (isLeft) {
      return isAisle ? { src: "/renders/shell-supview/LH-AisleSide-wograbrail.png", title: "LH \xB7 Aisle Side", code: "LH-A", isPlaceholder: false } : { src: "/renders/shell-supview/LH-WallSide-wograbrail.png", title: "LH \xB7 Wall Side", code: "LH-W", isPlaceholder: false };
    } else {
      return isAisle ? { src: "/renders/shell-supview/RH-Aisle Side-wograbrail.png", title: "RH \xB7 Aisle Side", code: "RH-A", isPlaceholder: false } : { src: "/renders/shell-supview/RH-Wall Side-wograbrail.png", title: "RH \xB7 Wall Side", code: "RH-W", isPlaceholder: false };
    }
  }, [seatPositionWog, vehicleSideWog]);
  const getPartImage = (partId) => {
    if (partId === 1) {
      return capColor === "Yellow" ? "/renders/shell/ShellLHwGrabrailyellowcap.png" : "/renders/shell/ShellLHwGrabrailgraycap.png";
    }
    if (partId === 2) {
      return "/renders/shell/ShellLHwoGrabrail.png";
    }
    if (partId === 3) {
      return C40_BACKREST_VARIANTS[c40BackrestVariant].image;
    }
    if (partId === 4) {
      return C40_SEAT_VARIANTS[c40SeatVariant].image;
    }
    if (partId === 5) {
      return C10_BACKREST_VARIANTS[c10BackrestVariant].image;
    }
    if (partId === 6) {
      return C10_SEAT_VARIANTS[c10SeatVariant].image;
    }
    if (partId === 7) {
      return "/renders/accessories/Spacer.png";
    }
    if (partId === 8) {
      return GRABRAIL_CAP_VARIANTS[grabrailCapVariant].image;
    }
    if (partId === 11) {
      return STANCHION_CUP_VARIANTS[stanchionSide].image;
    }
    if (partId === 9) {
      return "/renders/accessories/armrest.png";
    }
    if (partId === 12 || partId === 101 || partId === 102) {
      return "/renders/accessories/t-pedestal-cap.png";
    }
    if (partId === 10 || partId === 110 || partId === 111) {
      return "/renders/accessories/usb-charger.png";
    }
    if (partId === 13) {
      return "/renders/accessories/plastic-cap-alu.png";
    }
    if (partId === 14 || partId === 112) {
      return "/renders/accessories/rubber-bumper.png";
    }
    if (partId >= 103 && partId <= 105) {
      return "/renders/shell/ShellLHwGrabrailgraycap.png";
    }
    if (partId >= 106 && partId <= 109) {
      return "/renders/accessories/Spacer.png";
    }
    return "";
  };
  const getPartFasteners = (partId) => {
    if ((partId === 1 || partId === 2) && includeHardware[partId]) {
      return SHELL_FASTENERS_BOM;
    }
    if (partId === 7 && includeHardware[7]) {
      return SPACER_FASTENERS_BOM;
    }
    if (partId === 12 && includeHardware[12]) {
      return T_PEDESTAL_CONFIGS[tPedestalConfig].fasteners;
    }
    if (partId === 10 && includeHardware[10]) {
      return USB_FASTENERS_BOM;
    }
    if (partId === 14 && includeHardware[14]) {
      return RUBBER_FASTENERS_BOM;
    }
    return null;
  };
  const getFastenerKitMeta = (partId) => {
    if (partId === 1 || partId === 2) {
      return {
        partId,
        parentName: "Citos Seat Shell (Shell to Frame)",
        title: "Seat Shell Mounting Fasteners Kit",
        badge: "4 Sets / 12 pcs",
        subtitle: "Factory mounting hardware pack for Citos 10 / 40 seat shell to frame installation",
        items: SHELL_FASTENERS_BOM,
        note: "Each seat shell utilizes 4 complete fastener sets: 4x T-bolts (M8x30), 4x A8.4 washers, and 4x M8 flange locking nuts."
      };
    }
    if (partId === 7) {
      return {
        partId,
        parentName: "Citos Spacer (450mm Alignment Shim)",
        title: "Spacer Mounting Fasteners Kit",
        badge: "4 Fasteners Pack",
        subtitle: "Factory installation hardware pack for seat spacing and alignment shim",
        items: SPACER_FASTENERS_BOM,
        note: "Kit contains required M6 sap bolts (60mm and 90mm), matching DIN 9021 washers, and M985 nylon insert lock nuts."
      };
    }
    if (partId === 10) {
      return {
        partId,
        parentName: "Dual USB Type-A/C Charging Module",
        title: "USB Module Mounting Fasteners Kit",
        badge: "2x Bolts + 2x Nuts",
        subtitle: "Certified mounting hardware for securing the USB enclosure",
        items: USB_FASTENERS_BOM,
        note: "Pos. 510 Socket cap bolt M4x12 (PN 302268) and Pos. 520 Dome cap nut M4 (PN 302458). Sheet metal seat mounting brackets will be offered as a separate accessory kit."
      };
    }
    if (partId === 12) {
      const isSingle = tPedestalConfig === "single";
      return {
        partId,
        parentName: `T-Pedestal Base Protective Cover (${isSingle ? "Single Cap" : "Full Foot"})`,
        title: "T-Pedestal Cap Fasteners Kit",
        badge: isSingle ? "4x Screws + 1x Washer" : "8x Screws + 2x Washers",
        subtitle: "Installation hardware pack for T-Pedestal plastic protective cover caps",
        items: T_PEDESTAL_CONFIGS[tPedestalConfig].fasteners,
        note: "Universal transit bus fastener kit using self-drilling DIN 7504M screws and stainless steel square alignment washers."
      };
    }
    if (partId === 14) {
      return {
        partId,
        parentName: "Rubber Bumper (1744 75 SHORE \xB7 Pos. 140)",
        title: "Rubber Bumper Mounting Screw",
        badge: "1x PT Screw",
        subtitle: "Factory certified mounting screw for rubber stop / vibration damper",
        items: RUBBER_FASTENERS_BOM,
        note: "Pos. 150 PT Screw 4x12 (WN 1411), PN 3008879. Factory fastening hardware for rubber bumper 1744 75 SHORE (PN 506691, Pos. 140)."
      };
    }
    return null;
  };
  const addHardwareItem = (id, pn, description, defaultQty = 1) => {
    const lineId = `HW-${pn}`;
    addCartLine(
      {
        lineId,
        partId: id,
        name: description,
        group: "Fasteners",
        description: `${description} (Certified Assembly Fastener)`,
        pn,
        configurationCode: `HW-${pn}`,
        customerNumber: "To be assigned",
        image: getPartImage(id),
        fasteners: null
      },
      defaultQty
    );
  };
  const addPart = (id, forceWithHw) => {
    if (id === 1) {
      const withHw = forceWithHw !== void 0 ? forceWithHw : !!includeHardware[1];
      const lineId = `shell-wg-${shellConfigurationCode}${withHw ? "-w-hw" : ""}`;
      const img = capColor === "Yellow" ? "/renders/shell/ShellLHwGrabrailyellowcap.png" : "/renders/shell/ShellLHwGrabrailgraycap.png";
      addCartLine({
        lineId,
        partId: 1,
        name: `Seat shell with grabrail (${shellModel} \xB7 ${seatPosition} \xB7 ${vehicleSide})`,
        group: "Shell",
        description: withHw ? `${shellDescription} [Includes factory shell mounting kit (4 sets): 4x T-bolt M8x30 (1041450), 4x Washer A8.4 (3008041), 4x Flange locking nut M8 (3009200)].` : shellDescription,
        pn: shellPn || shellConfigurationCode,
        configurationCode: withHw ? `${shellConfigurationCode}-W-FASTENERS` : shellConfigurationCode,
        customerNumber: withHw ? "+Fasteners Included" : "To be assigned",
        image: img,
        fasteners: withHw ? SHELL_FASTENERS_BOM : null
      }, 1);
    } else if (id === 2) {
      const withHw = forceWithHw !== void 0 ? forceWithHw : !!includeHardware[2];
      const lineId = `shell-wog-${shellWogConfigurationCode}${withHw ? "-w-hw" : ""}`;
      addCartLine({
        lineId,
        partId: 2,
        name: `Seat shell w/o grabrail (${shellModelWog} \xB7 ${seatPositionWog}${isVehicleSideDisabled ? "" : ` \xB7 ${vehicleSideWog}`})`,
        group: "Shell",
        description: withHw ? `${shellWogDescription} [Includes factory shell mounting kit (4 sets): 4x T-bolt M8x30 (1041450), 4x Washer A8.4 (3008041), 4x Flange locking nut M8 (3009200)].` : shellWogDescription,
        pn: shellWogPn || shellWogConfigurationCode,
        configurationCode: withHw ? `${shellWogConfigurationCode}-W-FASTENERS` : shellWogConfigurationCode,
        customerNumber: withHw ? "+Fasteners Included" : "To be assigned",
        image: "/renders/shell/ShellLHwoGrabrail.png",
        fasteners: withHw ? SHELL_FASTENERS_BOM : null
      }, 1);
    } else if (id === 3) {
      const activeC40 = C40_BACKREST_VARIANTS[c40BackrestVariant];
      const lineId = `c40-br-${activeC40.key}`;
      addCartLine({
        lineId,
        partId: 3,
        name: `Citos 40 Upholstered Backrest (${activeC40.title})`,
        group: "Upholstery",
        description: `${activeC40.description} [Foam: ${activeC40.foamSpec}]`,
        pn: activeC40.pn,
        configurationCode: `C40-BR-${activeC40.key}`,
        customerNumber: `Foam: ${activeC40.foamPn}`,
        image: activeC40.image,
        fasteners: null
      }, 1);
    } else if (id === 4) {
      const activeC40Seat = C40_SEAT_VARIANTS[c40SeatVariant];
      const lineId = `c40-seat-${activeC40Seat.key}`;
      addCartLine({
        lineId,
        partId: 4,
        name: `Citos 40 Upholstered Seat (${activeC40Seat.title})`,
        group: "Upholstery",
        description: `${activeC40Seat.description} [Standard Width]`,
        pn: activeC40Seat.pn,
        configurationCode: `C40-SEAT-${activeC40Seat.key}`,
        customerNumber: `Foam: ${activeC40Seat.foamPn}`,
        image: activeC40Seat.image,
        fasteners: null
      }, 1);
    } else if (id === 5) {
      const activeC10 = C10_BACKREST_VARIANTS[c10BackrestVariant];
      const lineId = `c10-br-${activeC10.standard.replace(/\s+/g, "")}-${activeC10.key.replace(/\s+/g, "")}`;
      addCartLine({
        lineId,
        partId: 5,
        name: `Citos 10 Backrest Insert (${activeC10.key} \xB7 ${activeC10.standard})`,
        group: "Inserts",
        description: `${activeC10.description} [${activeC10.standard} \xB7 ${activeC10.colorCode}]`,
        pn: activeC10.pn,
        configurationCode: `C10-BR-${activeC10.standard.replace(/\s+/g, "")}-${activeC10.key.replace(/\s+/g, "")}`,
        customerNumber: activeC10.bomRef || "512084",
        image: activeC10.image,
        fasteners: null
      }, 1);
    } else if (id === 6) {
      const activeC10Seat = C10_SEAT_VARIANTS[c10SeatVariant];
      const lineId = `c10-seat-${activeC10Seat.standard.replace(/\s+/g, "")}-${activeC10Seat.key.replace(/\s+/g, "")}`;
      addCartLine({
        lineId,
        partId: 6,
        name: `Citos 10 Seat Insert (${activeC10Seat.key} \xB7 ${activeC10Seat.standard})`,
        group: "Inserts",
        description: `${activeC10Seat.description} [Standard Width]`,
        pn: activeC10Seat.pn,
        configurationCode: `C10-SEAT-${activeC10Seat.standard.replace(/\s+/g, "")}-${activeC10Seat.key.replace(/\s+/g, "")}`,
        customerNumber: activeC10Seat.bomRef || "512086",
        image: activeC10Seat.image,
        fasteners: null
      }, 1);
    } else if (id === 7) {
      const activeSpacer = SPACER_VARIANTS[spacerStandard];
      const withHw = forceWithHw !== void 0 ? forceWithHw : !!includeHardware[7];
      const lineId = `spacer-${spacerStandard.replace(/\s+/g, "")}${withHw ? "-w-hw" : ""}`;
      addCartLine({
        lineId,
        partId: 7,
        name: `Spacer 450mm (${spacerStandard})`,
        group: "Spacer & GR Caps",
        description: withHw ? `${activeSpacer.description} [Includes factory mounting fastener kit: M6x60 bolt (4000031), M6x90 bolt (302335), 4x A6.4 washers (3008395), 2x M985 nylon nuts (3008371)].` : activeSpacer.description,
        pn: activeSpacer.pn,
        configurationCode: withHw ? `SPACER-${activeSpacer.key.replace(/\s+/g, "")}-W-FASTENERS` : `SPACER-${activeSpacer.key.replace(/\s+/g, "")}-STD`,
        customerNumber: withHw ? "+Fasteners Included" : "To be assigned",
        image: "/renders/accessories/Spacer.png",
        fasteners: withHw ? SPACER_FASTENERS_BOM : null
      }, 1);
    } else if (id === 8) {
      const activeCap = GRABRAIL_CAP_VARIANTS[grabrailCapVariant];
      const lineId = `gr-cap-${activeCap.key.replace(/\s+/g, "")}`;
      addCartLine({
        lineId,
        partId: 8,
        name: `Grabrail cap (${activeCap.title})`,
        group: "Spacer & GR Caps",
        description: activeCap.description,
        pn: activeCap.pn,
        configurationCode: `GR-CAP-${activeCap.key.replace(/\s+/g, "")}`,
        customerNumber: "To be assigned",
        image: activeCap.image,
        fasteners: null
      }, 1);
    } else if (id === 11) {
      const activeCup = STANCHION_CUP_VARIANTS[stanchionSide];
      const lineId = `stanchion-cup-${activeCup.key}`;
      addCartLine({
        lineId,
        partId: 11,
        name: `Stanchion cup (${activeCup.title})`,
        group: "Accessories",
        description: activeCup.description,
        pn: activeCup.pn,
        configurationCode: `STANCHION-CUP-${activeCup.key}`,
        customerNumber: "To be assigned",
        image: activeCup.image,
        fasteners: null
      }, 1);
    } else if (id === 9) {
      const activeArmrest = ARMREST_VARIANTS[armrestSeatSide];
      const lineId = `armrest-${activeArmrest.key}`;
      addCartLine({
        lineId,
        partId: 9,
        name: `Armrest assembly (${activeArmrest.title})`,
        group: "Accessories",
        description: activeArmrest.description,
        pn: activeArmrest.pn,
        configurationCode: `ARMREST-${activeArmrest.key}-${activeArmrest.pn}`,
        customerNumber: "To be assigned",
        image: "/renders/accessories/armrest.png",
        fasteners: null
      }, 1);
    } else if (id === 12) {
      const activePedestal = T_PEDESTAL_CONFIGS[tPedestalConfig];
      const withHw = forceWithHw !== void 0 ? forceWithHw : !!includeHardware[12];
      const lineId = `t-pedestal-${activePedestal.key}${withHw ? "-w-hw" : ""}`;
      addCartLine({
        lineId,
        partId: 12,
        name: `T-Pedestal plastic cap (${activePedestal.title})`,
        group: "Accessories",
        description: withHw ? `${activePedestal.description} [Includes mounting fastener kit: ${activePedestal.fasteners.map((f) => `${f.qty}x ${f.description} (${f.pn})`).join(", ")}].` : activePedestal.description,
        pn: activePedestal.pn,
        configurationCode: withHw ? `T-PEDESTAL-${activePedestal.key.toUpperCase()}-W-FASTENERS` : `T-PEDESTAL-${activePedestal.key.toUpperCase()}`,
        customerNumber: withHw ? "+Fasteners Included" : "To be assigned",
        image: "/renders/accessories/t-pedestal-cap.png",
        fasteners: withHw ? activePedestal.fasteners : null
      }, 1);
    } else if (id === 10) {
      const withHw = forceWithHw !== void 0 ? forceWithHw : !!includeHardware[10];
      const lineId = `usb-522898${withHw ? "-w-hw" : ""}`;
      addCartLine({
        lineId,
        partId: 10,
        name: "Dual USB Type-A/C charging module",
        group: "Accessories",
        description: withHw ? "Passenger Dual USB Type-A/C transit charging module enclosure with 60mm cable & MOLEX 3901-3023 plug [Includes factory mounting fastener kit: 2x Socket cap bolt M4x12 DIN 912 (302268), 2x Dome cap nut M4 DIN 986 (302458)]." : "Passenger Dual USB Type-A/C transit charging module enclosure with 60mm cable & MOLEX 3901-3023 plug.",
        pn: "522898",
        configurationCode: withHw ? "USB-DUAL-AC-522898-W-FASTENERS" : "USB-DUAL-AC-522898",
        customerNumber: "To be assigned",
        image: "/renders/accessories/usb-charger.png",
        fasteners: withHw ? USB_FASTENERS_BOM : null
      }, 1);
    } else if (id === 13) {
      const lineId = "alu-profile-cap-blk";
      addCartLine({
        lineId,
        partId: 13,
        name: "Aluminum profile cap",
        group: "Accessories",
        description: "Aluminum profile cap \u2014 Extruded aluminum frame profile end cap and edge finisher (BLACK)",
        pn: "Pending verified data",
        configurationCode: "ALU-PROFILE-CAP-BLK",
        customerNumber: "To be assigned",
        image: "/renders/accessories/plastic-cap-alu.png",
        fasteners: null
      }, 1);
    } else if (id === 14) {
      const withHw = forceWithHw !== void 0 ? forceWithHw : !!includeHardware[14];
      const lineId = `rubber-bumper-506691${withHw ? "-w-hw" : ""}`;
      addCartLine({
        lineId,
        partId: 14,
        name: "Rubber bumper (1744 75 SHORE)",
        group: "Accessories",
        description: withHw ? "Rubber bumper 1744 75 SHORE (PN 506691, Pos. 140) [Includes factory mounting screw: 1x PT Screw 4x12 WN 1411 (3008879, Pos. 150)]." : "Rubber bumper 1744 75 SHORE vibration damper and protective stop (PN 506691, Pos. 140).",
        pn: "506691",
        configurationCode: withHw ? "RUBBER-BUMPER-506691-W-FASTENER" : "RUBBER-BUMPER-506691",
        customerNumber: "Pos. 140",
        image: "/renders/accessories/rubber-bumper.png",
        fasteners: withHw ? RUBBER_FASTENERS_BOM : null
      }, 1);
    } else {
      const p = parts.find((item) => item.id === id);
      if (p) {
        const lineId = `part-${id}`;
        addCartLine({
          lineId,
          partId: id,
          name: p.name,
          group: p.group,
          description: p.description,
          pn: p.pn || "Pending verified data",
          configurationCode: "",
          customerNumber: p.customerNumber || "To be assigned",
          image: getPartImage(id),
          fasteners: null
        }, 1);
      }
    }
  };
  const openView = (next) => {
    setView(next);
    if (typeof window !== "undefined") {
      const targetHash = next === "home" ? "" : `#${next}`;
      if (window.location.hash !== targetHash) {
        if (targetHash === "") {
          history.pushState(null, "", window.location.pathname + window.location.search); // eslint-disable-line no-restricted-globals
        } else {
          window.location.hash = targetHash;
        }
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const currentNavigation = view === "standard-seats" ? null : navigation[view];
  return <main id="top"><header className="siteHeader"><button className="brand brandButton" onClick={() => openView("home")} aria-label="Kiel Genuine Spare Parts home"><img src="/kiel-logo.png" alt="Kiel Seating Solutions" /><span>Genuine Spare Parts</span></button><div className="headerActions"><span className="americaOnly">Kiel Americas only</span>{view === "standard-seats" && <button className="cartButton" onClick={() => setCartOpen(true)}>Request cart <b>{itemCount}</b></button>}</div></header>{currentNavigation && <section className="selectionPage"><div className="selectionIntro">{view !== "home" && <button className="backButton" onClick={() => openView(view === "citos" ? "city-bus" : "home")}>← Back</button>}<p className="eyebrow">{currentNavigation.eyebrow}</p><h1>{currentNavigation.title}</h1><p>{currentNavigation.copy}</p></div><div className={`selectionGrid selectionGrid${currentNavigation.cards.length}`}>{currentNavigation.cards.map((card, index) => <button key={card.title} className={`selectionCard ${card.active ? "available" : "disabled"}`} onClick={() => card.next && openView(card.next)} disabled={!card.active}><span className="cardIndex">0{index + 1}</span><span className="cardBody"><b>{card.title}</b><small>{card.copy}</small></span><span className="cardStatus">{card.tag}{card.active && " \u2192"}</span></button>)}</div><div className="selectionNote"><b>Kiel Americas</b><span>This spare parts request system is currently available for Kiel Americas customers.</span></div>{view === "home" && <div className="systemOverviewBox"><div className="systemOverviewHeader"><span className="systemBadge">System Overview</span><h3>What is this portal?</h3></div><p className="systemOverviewLead"><strong>Kiel Genuine Spare Parts & Order Portal</strong> is a specialized commercial application built for Kiel Americas transit bus operators, municipal maintenance depots, and fleet managers. It simplifies identifying, configuring, and requisitioning genuine Kiel replacement parts.
              </p><div className="systemOverviewGrid"><div className="overviewItem"><span className="overviewItemNumber">01</span><div className="overviewItemContent"><strong>Engineering-Verified Part Numbers (PN)</strong><p>Controlled Kiel PNs for Citos 10 / 40 shells, FMVSS 302 and Docket 90A standards, and foam inserts.</p></div></div><div className="overviewItem"><span className="overviewItemNumber">02</span><div className="overviewItemContent"><strong>Configurable Handing & Orientation</strong><p>Accurate Left Hand (LH) vs Right Hand (RH) seats, aisle/wall placements, and interactive armrest diagrams.</p></div></div><div className="overviewItem"><span className="overviewItemNumber">03</span><div className="overviewItemContent"><strong>Automated Fastener BOM Kits</strong><p>Bundle factory mounting screws, bolts, and washers or order loose hardware items directly with one click.</p></div></div><div className="overviewItem"><span className="overviewItemNumber">04</span><div className="overviewItemContent"><strong>Request Cart & PO Drafting</strong><p>Build real-time parts lists, generate print-ready BOM sheets, and prepare pre-filled quote requests for Kiel Americas.</p></div></div></div></div>}</section>}{view === "standard-seats" && <><nav className="breadcrumbs" aria-label="Breadcrumb"><button onClick={() => openView("home")}>Transport</button><span>/</span><button onClick={() => openView("city-bus")}>City Bus</button><span>/</span><button onClick={() => openView("citos")}>Citos</button><span>/</span><b>Standard Seats</b></nav><section className="productIntro"><div className="introCopy"><p className="eyebrow">CITY BUS · STANDARD SEATING</p><h1>Standard Seat</h1><p className="lead">Find the correct spare part, add the required quantity and create one clear parts list or purchase order.</p><div className="heroSearch"><label htmlFor="parts-search">Search genuine spare parts</label><div className="searchControl"><span className="searchIcon" aria-hidden="true" /><input
    id="parts-search"
    ref={searchRef}
    value={query}
    onChange={(event) => {
      setQuery(event.target.value);
      setSearchOpen(true);
    }}
    onFocus={() => setSearchOpen(true)}
    onBlur={() => window.setTimeout(() => setSearchOpen(false), 150)}
    onKeyDown={(event) => event.key === "Escape" && setSearchOpen(false)}
    placeholder="Search by part name, PN or customer number"
    autoComplete="off"
  />{query && <button className="clearSearch" onClick={() => {
    setQuery("");
    setGroup("All parts");
  }} aria-label="Clear search">×</button>}<span className="searchHint">⌘ K</span></div>{searchOpen && query.trim() && <div className="searchSuggestions"><div className="suggestionHeader"><span>Best matches</span><b>{rankedParts.length} results</b></div>{rankedParts.slice(0, 5).map((part) => <button key={part.id} onMouseDown={() => chooseSuggestion(part)}><span className="suggestionThumb">+</span><span><b>{part.name}</b><small>{part.group} · PN pending verification</small></span><i>View</i></button>)}{!rankedParts.length && <div className="suggestionEmpty"><b>No matching parts</b><span>Try a part name, PN or customer number.</span></div>}</div>}</div><div className="quickSteps" aria-label="How it works"><span><b>01</b> Select a part</span><span><b>02</b> Build your list</span><span><b>03</b> Export or email</span></div><a className="primaryAction" href="#parts">Browse spare parts</a></div><div
    className="seatVisual"
    onMouseEnter={() => setIsPaused(true)}
    onMouseLeave={() => setIsPaused(false)}
  ><div className="seatVisualHeader"><div className="seatSelector" aria-label="Choose Citos seat model"><button
    className={seatModel === "Citos 10" ? "active" : ""}
    onClick={() => {
      if (seatModel !== "Citos 10") {
        setActiveSlideIndex(0);
      }
    }}
  >
                Citos 10
              </button><button
    className={seatModel === "Citos 40" ? "active" : ""}
    onClick={() => {
      const idx = RENDER_SLIDES.findIndex((s) => s.model === "Citos 40");
      if (idx !== -1) setActiveSlideIndex(idx);
    }}
  >
                Citos 40
              </button></div>{seatModel === "Citos 10" && <div className="colorSwatches" aria-label="Choose seat color"><span className="swatchesLabel">Color:</span><button
    type="button"
    className={`swatchBall ${currentSlide.id === "c10-gray" ? "active" : ""}`}
    style={{ backgroundColor: "#3a3f45" }}
    onClick={() => setActiveSlideIndex(0)}
    title="Dark Gray"
    aria-label="Citos 10 Dark Gray"
  /><button
    type="button"
    className={`swatchBall ${currentSlide.id === "c10-blue" ? "active" : ""}`}
    style={{ backgroundColor: "#1658a5" }}
    onClick={() => setActiveSlideIndex(1)}
    title="Kiel Blue"
    aria-label="Citos 10 Kiel Blue"
  /></div>}</div><div className="seatRender">{RENDER_SLIDES.map((slide, idx) => <img
    key={slide.id}
    src={slide.image}
    alt={slide.label}
    className={`renderImage ${idx === activeSlideIndex ? "visible" : ""}`}
    loading="eager"
    decoding="async"
  />)}</div><aside className="verticalBadge" aria-label="Selected seat configuration"><span>{currentSlide.label}</span></aside><div className="seatVisualFooter"><div className="carouselIndicators" aria-label="Slide indicators">{RENDER_SLIDES.map((slide, idx) => <button
    key={slide.id}
    type="button"
    className={`indicatorDot ${idx === activeSlideIndex ? "active" : ""}`}
    onClick={() => setActiveSlideIndex(idx)}
    aria-label={`Switch to ${slide.label}`}
  />)}</div><span className="slideCounter">0{activeSlideIndex + 1} / 0{RENDER_SLIDES.length}</span></div></div></section><section className="catalog" id="parts"><div className="catalogHeading"><div><p className="eyebrow">SPARE PARTS CATALOG</p><h2>Parts for {seatModel} Standard Seat</h2><p>Images and verified engineering numbers will be added as product data is released.</p></div><div className="resultsMeta"><b>{visibleParts.length}</b><span>{query ? `results for \u201C${query}\u201D` : "available parts"}</span>{query && <button onClick={() => {
    setQuery("");
    setGroup("All parts");
  }}>Clear search</button>}</div></div><div className="catalogBody"><aside className="categoryPanel" aria-label="Part categories"><h3>Categories</h3>{groups.map((item) => <button key={item} className={group === item ? "active" : ""} onClick={() => setGroup(item)}><span>{item}</span><b>{item === "All parts" ? parts.length : parts.filter((part) => part.group === item).length}</b></button>)}</aside><div className="productGrid">{(() => {
    const renderPartCard = (part) => <article className="partCard" key={part.id}>{part.id === 1 ? <div className={`shellImage ${shellStandard === "Doc 90" ? "doc90" : "fmvss"}`}><img
      src={capColor === "Yellow" ? "/renders/shell/ShellLHwGrabrailyellowcap.png" : "/renders/shell/ShellLHwGrabrailgraycap.png"}
      alt={`${shellStandard} Citos seat shell with grabrail (${capColor} cap)`}
      className="mainShellImg"
    /><div className="shellAuxView" aria-label="Support orientation diagram"><div className="auxHeader"><span className="auxTag">Support view</span><b>{shellAuxImage.title}</b></div><img
      key={shellAuxImage.src}
      src={shellAuxImage.src}
      alt={shellAuxImage.title}
      className="auxImg"
    /></div></div> : part.id === 2 ? <div className={`shellImage ${shellStandardWog === "Doc 90" ? "doc90" : "fmvss"}`}><img
      src="/renders/shell/ShellLHwoGrabrail.png"
      alt={`${shellStandardWog} Citos seat shell without grabrail`}
      className="mainShellImg"
    /><div className="shellAuxView" aria-label="Support orientation diagram"><div className="auxHeader"><span className="auxTag">Support view</span><b>{shellWogAuxImage.title}</b></div>{shellWogAuxImage.isPlaceholder ? <div className="auxPlaceholder"><span className="auxPlaceholderIcon">◫</span><b>{shellWogAuxImage.title}</b><small>Support render in preparation</small></div> : <img
      key={shellWogAuxImage.src}
      src={shellWogAuxImage.src}
      alt={shellWogAuxImage.title}
      className="auxImg"
    />}</div></div> : part.id === 7 ? <div className="accessoryVisual"><img
      src="/renders/accessories/Spacer.png"
      alt="Citos Seat Spacer"
      className="mainShellImg"
    /></div> : part.id === 8 ? <div className="accessoryVisual"><img
      src={GRABRAIL_CAP_VARIANTS[grabrailCapVariant].image}
      alt="Grabrail Replacement End Cap"
      className="mainShellImg"
    /></div> : part.id === 11 ? <div className="accessoryVisual hasAux"><div className="auxViewToggle"><button
      type="button"
      className={stanchionViewMode === "3d" ? "active" : ""}
      onClick={() => setStanchionViewMode("3d")}
    >
                          3D View
                        </button><button
      type="button"
      className={stanchionViewMode === "aux" ? "active" : ""}
      onClick={() => setStanchionViewMode("aux")}
    >
                          📐 Diagram
                        </button></div>{stanchionViewMode === "3d" ? <img
      src={STANCHION_CUP_VARIANTS[stanchionSide].image}
      alt="Stanchion Cup"
      className="mainShellImg"
    /> : <div className="stanchionAuxContainer"><img
      src={STANCHION_CUP_VARIANTS[stanchionSide].auxImage}
      alt="Stanchion Cup Technical Diagram"
      className="stanchionAuxImg"
    /><span className="auxSpecTag">PN {STANCHION_CUP_VARIANTS[stanchionSide].pn} · MAX 150 (5.90&quot;)</span></div>}</div> : part.id === 9 ? <div className="accessoryVisual hasAux"><div className="auxViewToggle"><button
      type="button"
      className={armrestViewMode === "3d" ? "active" : ""}
      onClick={() => setArmrestViewMode("3d")}
    >
                          3D View
                        </button><button
      type="button"
      className={armrestViewMode === "aux" ? "active" : ""}
      onClick={() => setArmrestViewMode("aux")}
    >
                          📐 Diagram
                        </button></div>{armrestViewMode === "3d" ? <img
      src="/renders/accessories/armrest.png"
      alt="Armrest Assembly"
      className={`mainShellImg ${armrestSeatSide === "RH" ? "mirroredImg" : ""}`}
    /> : <div className="stanchionAuxContainer armrestAuxContainer"><img
      src="/renders/accessories/SingleSeat.png"
      alt="Single Seat Armrest Diagram"
      className={`stanchionAuxImg armrestAuxImg ${armrestSeatSide === "RH" ? "mirroredImg" : ""}`}
    /><span className="auxSpecTag">
                            PN {ARMREST_VARIANTS[armrestSeatSide].pn} · {ARMREST_VARIANTS[armrestSeatSide].armrestType}</span></div>}</div> : part.id === 10 ? <div className="accessoryVisual"><img
      src="/renders/accessories/usb-charger.png"
      alt="Dual USB Type-A/C Charging Module"
      className="mainShellImg"
    /></div> : part.id === 12 ? <div className="accessoryVisual"><img
      src="/renders/accessories/t-pedestal-cap.png"
      alt="T-Pedestal Plastic Cap"
      className="mainShellImg"
    /></div> : part.id === 13 ? <div className="accessoryVisual"><img
      src="/renders/accessories/plastic-cap-alu.png"
      alt="Aluminum Profile Cap"
      className="mainShellImg"
    /></div> : part.id === 14 ? <div className="accessoryVisual"><img
      src="/renders/accessories/rubber-bumper.png"
      alt="Rubber Bumper 1744 75 SHORE"
      className="mainShellImg"
    /></div> : <Placeholder compact />}<div className="partContent"><p className="partGroup">{part.group}</p><h3>{part.name}</h3><p className="partDescription">{part.id === 1 ? shellDescription : part.id === 2 ? shellWogDescription : part.description}</p>{part.id === 1 && <div className="shellConfigurator"><fieldset><legend>Seat Model</legend><div className="segmented">{["Citos 10", "Citos 40"].map((model) => <button key={model} type="button" className={shellModel === model ? "active" : ""} onClick={() => {
      setShellModel(model);
      if (model === "Citos 40") {
        setShellStandard("FMVSS 302");
        setCapColor("Dark Gray");
      }
    }}>{model}</button>)}</div></fieldset><fieldset><legend>Material / Fire Safety Standard{shellModel === "Citos 40" && <span className="legendNote"> — Doc 90 unavailable for Citos 40</span>}</legend><div className="colorChoices"><button type="button" className={shellStandard === "FMVSS 302" ? "active" : ""} onClick={() => {
      setShellStandard("FMVSS 302");
      setCapColor("Dark Gray");
    }}><i className="swatch fmvss" /><span>FMVSS 302<small>Shell NCS S 6000-N · Handle NCS S 8000-N</small></span></button><button
      type="button"
      disabled={shellModel === "Citos 40"}
      className={shellStandard === "Doc 90" ? "active" : ""}
      onClick={() => {
        if (shellModel !== "Citos 40") {
          setShellStandard("Doc 90");
          setCapColor("Yellow");
        }
      }}
      title={shellModel === "Citos 40" ? "Doc 90 is unavailable for Citos 40" : "Doc 90"}
    ><i className="swatch doc90" /><span>Doc 90<small>{shellModel === "Citos 40" ? "Unavailable for Citos 40" : "Shell NCS S 6000-N \xB7 Handle RAL 1023"}</small></span></button></div></fieldset><fieldset><legend>Grabrail Cap Color{shellStandard === "FMVSS 302" && <span className="legendNote"> — Yellow unavailable in FMVSS 302</span>}{shellStandard === "Doc 90" && <span className="legendNote"> — Dark Gray unavailable in Doc 90</span>}</legend><div className="colorChoices"><button
      type="button"
      disabled={shellStandard === "Doc 90"}
      className={capColor === "Dark Gray" ? "active" : ""}
      onClick={() => {
        if (shellStandard !== "Doc 90") setCapColor("Dark Gray");
      }}
      title={shellStandard === "Doc 90" ? "Dark Gray cap is unavailable with Doc 90" : "Dark Gray (NCS S 8000-N)"}
    ><i className="swatch darkGray" /><span>Dark Gray<small>NCS S 8000-N · {shellStandard === "Doc 90" ? "Unavailable in Doc 90" : "Standard"}</small></span></button><button
      type="button"
      disabled={shellStandard === "FMVSS 302"}
      className={capColor === "Yellow" ? "active" : ""}
      onClick={() => {
        if (shellStandard !== "FMVSS 302") setCapColor("Yellow");
      }}
      title={shellStandard === "FMVSS 302" ? "Yellow cap is unavailable with FMVSS 302" : "Yellow (RAL 1023)"}
    ><i className="swatch yellow" /><span>Yellow<small>RAL 1023 · {shellStandard === "FMVSS 302" ? "Unavailable in FMVSS 302" : "Standard \xB7 Doc 90"}</small></span></button></div></fieldset><fieldset><legend>Seat position</legend><div className="segmented">{["Left seat", "Right seat"].map((value) => <button key={value} type="button" className={seatPosition === value ? "active" : ""} onClick={() => setSeatPosition(value)}>{value}</button>)}</div></fieldset><fieldset><legend>Vehicle side</legend><div className="segmented">{["Aisle side", "Wall side"].map((value) => <button key={value} type="button" className={vehicleSide === value ? "active" : ""} onClick={() => setVehicleSide(value)}>{value}</button>)}</div></fieldset><div className="configurationCode"><span>Configuration code</span><b>{shellConfigurationCode}</b>{shellPn ? <div className="configurationPnBadge verified"><span>Official Kiel Part No (PN)</span><b>{shellPn}</b></div> : <small>Verified Kiel PN pending release</small>}</div></div>}{part.id === 2 && <div className="shellConfigurator"><fieldset><legend>Seat Model</legend><div className="segmented">{["Citos 10", "Citos 40"].map((model) => <button key={model} type="button" className={shellModelWog === model ? "active" : ""} onClick={() => {
      setShellModelWog(model);
      if (model === "Citos 40") {
        setShellStandardWog("FMVSS 302");
      }
    }}>{model}</button>)}</div></fieldset><fieldset><legend>Material / Fire Safety Standard{shellModelWog === "Citos 40" && <span className="legendNote"> — Doc 90 unavailable for Citos 40</span>}</legend><div className="colorChoices"><button type="button" className={shellStandardWog === "FMVSS 302" ? "active" : ""} onClick={() => setShellStandardWog("FMVSS 302")}><i className="swatch fmvss" /><span>FMVSS 302<small>Shell NCS S 6000-N</small></span></button><button
      type="button"
      disabled={shellModelWog === "Citos 40"}
      className={shellStandardWog === "Doc 90" ? "active" : ""}
      onClick={() => {
        if (shellModelWog !== "Citos 40") {
          setShellStandardWog("Doc 90");
        }
      }}
      title={shellModelWog === "Citos 40" ? "Doc 90 is unavailable for Citos 40" : "Doc 90"}
    ><i className="swatch doc90" /><span>Doc 90<small>{shellModelWog === "Citos 40" ? "Unavailable for Citos 40" : "Shell NCS S 6000-N"}</small></span></button></div></fieldset><fieldset><legend>Seat position</legend><div className="segmented grid4">{["Left seat", "Right seat", "Middle seat", "Single seat"].map((value) => <button key={value} type="button" className={seatPositionWog === value ? "active" : ""} onClick={() => setSeatPositionWog(value)}>{value}</button>)}</div></fieldset><fieldset><legend>Vehicle side {isVehicleSideDisabled && <span className="legendNote">— N/A for {seatPositionWog.toLowerCase()}</span>}</legend><div className="segmented">{["Aisle side", "Wall side"].map((value) => <button key={value} type="button" disabled={isVehicleSideDisabled} className={!isVehicleSideDisabled && vehicleSideWog === value ? "active" : ""} onClick={() => setVehicleSideWog(value)}>{value}</button>)}</div></fieldset><div className="configurationCode"><span>Configuration code</span><b>{shellWogConfigurationCode}</b>{shellWogPn ? <div className="configurationPnBadge verified"><span>Official Kiel Part No (PN)</span><b>{shellWogPn}</b></div> : <small>Verified Kiel PN pending release</small>}</div></div>}{(part.id === 1 || part.id === 2) && <div className="compactFastenerBar"><label className="compactFastenerCheckbox"><input
      type="checkbox"
      checked={!!includeHardware[part.id]}
      onChange={() => toggleHardware(part.id)}
    /><span className="compactCheckCustom">{includeHardware[part.id] && "\u2713"}</span><span className="compactCheckText"><b>Include Fasteners Kit</b><small>4 Sets / 12 pcs</small></span></label><button
      type="button"
      className="viewFastenersBtn"
      onClick={() => setFastenerModalPartId(part.id)}
    >
                          View BOM ↗
                        </button></div>}{part.id === 7 && <div className="shellConfigurator"><fieldset><legend>Fire Safety Standard</legend><div className="colorChoices"><button
      type="button"
      className={spacerStandard === "FMVSS 302" ? "active" : ""}
      onClick={() => setSpacerStandard("FMVSS 302")}
    ><i className="swatch fmvss" /><span>FMVSS 302<small>RAL NCS S 6000-N</small></span></button><button
      type="button"
      className={spacerStandard === "Doc 90" ? "active" : ""}
      onClick={() => setSpacerStandard("Doc 90")}
    ><i className="swatch doc90" /><span>Doc 90<small>Docket 90A Spec</small></span></button></div></fieldset><div className="compactFastenerBar" style={{ marginTop: "12px" }}><label className="compactFastenerCheckbox"><input
      type="checkbox"
      checked={!!includeHardware[part.id]}
      onChange={() => toggleHardware(part.id)}
    /><span className="compactCheckCustom">{includeHardware[part.id] && "\u2713"}</span><span className="compactCheckText"><b>Include Spacer Fastener Kit</b><small>4 Items (Bolts, Washers, Nuts)</small></span></label><button
      type="button"
      className="viewFastenersBtn"
      onClick={() => setFastenerModalPartId(part.id)}
    >
                            View BOM ↗
                          </button></div></div>}{part.id === 8 && <div className="shellConfigurator"><fieldset><legend>Cap Color</legend><div className="colorChoices"><button
      type="button"
      className={grabrailCapVariant === "Dark Gray" ? "active" : ""}
      onClick={() => setGrabrailCapVariant("Dark Gray")}
    ><i className="swatch darkGray" /><span>Dark Gray<small>NCS S 8000-N · FMVSS 302</small></span></button><button
      type="button"
      className={grabrailCapVariant === "Yellow" ? "active" : ""}
      onClick={() => setGrabrailCapVariant("Yellow")}
    ><i className="swatch yellow" /><span>Yellow (Doc 90)<small>RAL 1023 · Docket 90A</small></span></button></div></fieldset></div>}{part.id === 11 && <div className="shellConfigurator"><fieldset><legend>Mounting Side (Handing)</legend><div className="colorChoices"><button
      type="button"
      className={stanchionSide === "LH" ? "active" : ""}
      onClick={() => setStanchionSide("LH")}
    ><i className="swatch darkGray" /><span>LH · Left Hand<small>Official Kiel PN: 169716</small></span></button><button
      type="button"
      className={stanchionSide === "RH" ? "active" : ""}
      onClick={() => setStanchionSide("RH")}
    ><i className="swatch darkGray" /><span>RH · Right Hand<small>Official Kiel PN: 169715</small></span></button></div></fieldset></div>}{part.id === 9 && <div className="shellConfigurator"><fieldset><legend>Seat Placement &amp; Armrest Handing</legend><div className="colorChoices"><button
      type="button"
      className={armrestSeatSide === "LH" ? "active" : ""}
      onClick={() => setArmrestSeatSide("LH")}
    ><i className="swatch darkGray" /><span>
                                Left Seat (LH)
                                <small>Aisle Armrest: RH · PN 184139</small></span></button><button
      type="button"
      className={armrestSeatSide === "RH" ? "active" : ""}
      onClick={() => setArmrestSeatSide("RH")}
    ><i className="swatch darkGray" /><span>
                                Right Seat (RH)
                                <small>Aisle Armrest: LH · PN 184138</small></span></button></div></fieldset><div className="armrestNoticeBox"><span className="armrestNoticeTitle">ℹ️ Installation &amp; Diagram Reference:</span><span className="armrestNoticeDesc">{armrestSeatSide === "LH" ? "For a Left Seat (LH), the aisle-side armrest requires Right Hand reference (RH Armrest \xB7 PN 184139). Diagram shows standard LH single seat assembly." : "For a Right Seat (RH), the aisle-side armrest requires Left Hand reference (LH Armrest \xB7 PN 184138). Diagram is mirrored horizontally for RH seat symmetry."}</span></div></div>}{part.id === 12 && <div className="shellConfigurator"><fieldset><legend>Purchase Scope &amp; Pedestal Quantity</legend><div className="colorChoices"><button
      type="button"
      className={tPedestalConfig === "single" ? "active" : ""}
      onClick={() => setTPedestalConfig("single")}
    ><i className="swatch darkGray" /><span>
                                Single Cap (1x Cover)
                                <small>1x Cap · PN 519162 (Single replacement)</small></span></button><button
      type="button"
      className={tPedestalConfig === "pedestal" ? "active" : ""}
      onClick={() => setTPedestalConfig("pedestal")}
    ><i className="swatch darkGray" /><span>
                                Full Pedestal (1 Foot / 2x Caps)
                                <small>2x Caps · Complete front &amp; rear foot coverage</small></span></button></div></fieldset><div className="compactFastenerBar" style={{ marginTop: "12px" }}><label className="compactFastenerCheckbox"><input
      type="checkbox"
      checked={!!includeHardware[part.id]}
      onChange={() => toggleHardware(part.id)}
    /><span className="compactCheckCustom">{includeHardware[part.id] && "\u2713"}</span><span className="compactCheckText"><b>Include Fastener Kit</b><small>{tPedestalConfig === "single" ? "4x screws, 1x washer" : "8x screws, 2x washers"}</small></span></label><button
      type="button"
      className="viewFastenersBtn"
      onClick={() => setFastenerModalPartId(part.id)}
    >
                            View BOM ↗
                          </button></div><div className="armrestNoticeBox"><span className="armrestNoticeTitle">ℹ️ Universal Seating Component:</span><span className="armrestNoticeDesc">
                            Standard protective foot cover utilized across standard transit bus configurations. 1 plastic cover utilizes 4 self-drilling screws; 1 full pedestal foot utilizes 2 black plastic covers (PN 519162) and 8 screws.
                          </span></div></div>}{part.id === 13 && <div className="shellConfigurator"><div className="armrestNoticeBox"><span className="armrestNoticeTitle">ℹ️ Profile End Finisher:</span><span className="armrestNoticeDesc">
                            Snap-in protective black plastic end cap for standard extruded aluminum frame seat profiles. Official Kiel Part Number release pending.
                          </span></div></div>}{part.id === 10 && <div className="shellConfigurator"><div className="compactFastenerBar"><label className="compactFastenerCheckbox"><input
      type="checkbox"
      checked={!!includeHardware[part.id]}
      onChange={() => toggleHardware(part.id)}
    /><span className="compactCheckCustom">{includeHardware[part.id] && "\u2713"}</span><span className="compactCheckText"><b>Include Fastener Kit</b><small>2x M4 Bolts + 2x Nuts</small></span></label><button
      type="button"
      className="viewFastenersBtn"
      onClick={() => setFastenerModalPartId(part.id)}
    >
                            View BOM ↗
                          </button></div><button
      type="button"
      className="viewSpecSheetBtn"
      onClick={() => setUsbSpecOpen(true)}
    >
                          ⚡ View Electrical &amp; Wiring Spec Sheet ↗
                        </button></div>}{part.id === 14 && <div className="shellConfigurator"><div className="compactFastenerBar"><label className="compactFastenerCheckbox"><input
      type="checkbox"
      checked={!!includeHardware[part.id]}
      onChange={() => toggleHardware(part.id)}
    /><span className="compactCheckCustom">{includeHardware[part.id] && "\u2713"}</span><span className="compactCheckText"><b>Include Mounting Screw</b><small>1x PT Screw 4x12 (WN 1411)</small></span></label><button
      type="button"
      className="viewFastenersBtn"
      onClick={() => setFastenerModalPartId(part.id)}
    >
                            View BOM ↗
                          </button></div></div>}<dl><div><dt>PN</dt><dd className={part.id === 1 ? shellPn ? "verifiedPn" : "" : part.id === 2 ? shellWogPn ? "verifiedPn" : "" : part.id === 7 ? "verifiedPn" : part.id === 8 ? GRABRAIL_CAP_VARIANTS[grabrailCapVariant].pn !== "Pending release" ? "verifiedPn" : "" : part.id === 11 ? "verifiedPn" : part.id === 9 ? "verifiedPn" : part.id === 12 ? "verifiedPn" : part.pn ? "verifiedPn" : ""}>{part.id === 1 ? shellPn ? <b>{shellPn}</b> : shellConfigurationCode : part.id === 2 ? shellWogPn ? <b>{shellWogPn}</b> : shellWogConfigurationCode : part.id === 7 ? <b>{SPACER_VARIANTS[spacerStandard].pn}</b> : part.id === 8 ? GRABRAIL_CAP_VARIANTS[grabrailCapVariant].pn !== "Pending release" ? <b>{GRABRAIL_CAP_VARIANTS[grabrailCapVariant].pn}</b> : "Pending verified data" : part.id === 11 ? <b>{STANCHION_CUP_VARIANTS[stanchionSide].pn}</b> : part.id === 9 ? <b>{ARMREST_VARIANTS[armrestSeatSide].pn}</b> : part.id === 12 ? <b>{T_PEDESTAL_CONFIGS[tPedestalConfig].pn}</b> : part.pn ? <b>{part.pn}</b> : "Pending verified data"}</dd></div><div><dt>Customer no.</dt><dd>{part.customerNumber ? <b>{part.customerNumber}</b> : <span className="pendingText">To be assigned</span>}</dd></div>{part.id === 7 && <div><dt>Standard</dt><dd>{spacerStandard} ({SPACER_VARIANTS[spacerStandard].colorCode})</dd></div>}{(part.id === 1 || part.id === 2) && includeHardware[part.id] && <div><dt>Hardware</dt><dd><b>+ Shell Mounting Kit (12 pcs / 4 sets)</b></dd></div>}{part.id === 7 && includeHardware[7] && <div><dt>Hardware</dt><dd><b>+ Fastener Kit Included (4 items)</b></dd></div>}{part.id === 8 && <div><dt>Color</dt><dd>{GRABRAIL_CAP_VARIANTS[grabrailCapVariant].colorCode}</dd></div>}{part.id === 11 && <><div><dt>Orientation</dt><dd>{stanchionSide === "LH" ? "Left Hand (LH)" : "Right Hand (RH)"}</dd></div><div><dt>Offset Spec</dt><dd>MAX 150 (5.90&quot;)</dd></div></>}{part.id === 9 && <><div><dt>Seat Placement</dt><dd>{ARMREST_VARIANTS[armrestSeatSide].seatLabel}</dd></div><div><dt>Armrest Handing</dt><dd>{ARMREST_VARIANTS[armrestSeatSide].armrestType}</dd></div><div><dt>Mounting Side</dt><dd>{ARMREST_VARIANTS[armrestSeatSide].mountingSide}</dd></div></>}{part.id === 12 && <><div><dt>Cap Part No.</dt><dd>519162 (BLACK)</dd></div><div><dt>Configuration</dt><dd>{T_PEDESTAL_CONFIGS[tPedestalConfig].title}</dd></div>{includeHardware[12] && <div><dt>Hardware</dt><dd><b>+ Fastener Kit Included ({tPedestalConfig === "single" ? "4x screws, 1x washer" : "8x screws, 2x washers"})</b></dd></div>}<div><dt>Application</dt><dd>Universal Transit Seating (Multi-fleet)</dd></div></>}{part.id === 13 && <><div><dt>Color</dt><dd>Black</dd></div><div><dt>Profile Type</dt><dd>Extruded Aluminum Frame Profile</dd></div><div><dt>Catalog Status</dt><dd>Official Part Number pending</dd></div></>}{part.id === 10 && <><div><dt>Port Configuration</dt><dd>Dual Ports (1x Type-A + 1x Type-C + LED)</dd></div><div><dt>Cable Harness</dt><dd>60mm (6cm) integrated pigtail lead</dd></div><div><dt>Connector Type</dt><dd><b>MOLEX 3901-3023</b></dd></div>{includeHardware[10] && <div><dt>Hardware Kit</dt><dd><b>+ Fastener Kit Included (2x M4x12 bolts, 2x M4 dome nuts)</b></dd></div>}<div><dt>Mounting Bracket</dt><dd>Sheet metal bracket offered separately</dd></div></>}{part.id === 14 && <><div><dt>Specification</dt><dd>1744 75 SHORE Rubber</dd></div><div><dt>BOM Position</dt><dd>Pos. 140</dd></div>{includeHardware[14] && <div><dt>Hardware</dt><dd><b>+ 1x PT Screw 4x12 WN 1411 (PN 3008879, Pos. 150)</b></dd></div>}</>}</dl><button className="addButton" onClick={() => addPart(part.id)}>Add to request</button></div></article>;
    const isAllPartsView = group === "All parts" && !query.trim();
    const renderC40UpholsteryCard = () => {
      const activeC40Backrest = C40_BACKREST_VARIANTS[c40BackrestVariant];
      const activeC40Seat = C40_SEAT_VARIANTS[c40SeatVariant];
      return <article className="systemCard" key="c40-upholstery-system"><div className="systemCardHeader"><div><span className="systemTag">CITOS 40 · UPHOLSTERED SYSTEM (PADDED)</span><h3>Citos 40 Upholstery Components</h3><p>High-comfort ergonomic upholstered backrest and seat cushion set.</p></div><span className="systemBadge">2 Parts</span></div><div className="systemComponentsGrid">{
        /* C40 Backrest with Image & Variant Selector */
      }<div className="componentRow" key="c40-backrest"><div className="componentVisual"><img
        src={activeC40Backrest.image}
        alt={activeC40Backrest.description}
        className="componentRenderImg"
      /><span className="componentTypeBadge">Backrest Cushion</span></div><div className="componentContent"><h4>Citos 40 Upholstered Backrest</h4><div className="componentSelector" aria-label="Citos 40 backrest vinyl selection"><button
        type="button"
        className={c40BackrestVariant === "NJT" ? "active" : ""}
        onClick={() => setC40BackrestVariant("NJT")}
      >
                              NJT (Morbern Navy)
                            </button><button
        type="button"
        className={c40BackrestVariant === "Olympia" ? "active" : ""}
        onClick={() => setC40BackrestVariant("Olympia")}
      >
                              Olympia (Momentum)
                            </button></div><div className="componentSpecPills"><span className="specPill trim"><i className="specIcon">✦</i> {activeC40Backrest.trim}</span><span className="specPill foam"><i className="specIcon">▦</i> Foam: <b>{activeC40Backrest.foamSpec}</b> <small>(BOM: {activeC40Backrest.foamPn})</small></span></div><p className="componentDesc">{activeC40Backrest.description}</p><dl className="componentDl"><div><dt>PN (Assembly)</dt><dd className="verifiedPn"><b>{activeC40Backrest.pn}</b></dd></div><div><dt>Customer no.</dt><dd><span className="pendingText">To be assigned</span></dd></div><div><dt>Foam / Padding</dt><dd><b>{activeC40Backrest.foamSpec}</b></dd></div><div><dt>Specification</dt><dd>{activeC40Backrest.badge}</dd></div></dl><button type="button" className="addButton" onClick={() => addPart(3)}>
                            Add to request
                          </button></div></div>{
        /* C40 Seat Cushion with Image & Variant Selector */
      }<div className="componentRow" key="c40-seat"><div className="componentVisual"><img
        src={activeC40Seat.image}
        alt={activeC40Seat.description}
        className="componentRenderImg"
      /><span className="componentTypeBadge">Seat Cushion</span></div><div className="componentContent"><h4>Citos 40 Upholstered Seat</h4><div className="componentSelector" aria-label="Citos 40 seat vinyl selection"><button
        type="button"
        className={c40SeatVariant === "NJT" ? "active" : ""}
        onClick={() => setC40SeatVariant("NJT")}
      >
                              NJT (Morbern Navy)
                            </button><button
        type="button"
        className={c40SeatVariant === "Olympia" ? "active" : ""}
        onClick={() => setC40SeatVariant("Olympia")}
      >
                              Olympia (Momentum)
                            </button></div><div className="componentSpecPills"><span className="specPill trim"><i className="specIcon">✦</i> {activeC40Seat.trim}</span><span className="specPill foam"><i className="specIcon">▦</i> Foam: <b>{activeC40Seat.foamSpec}</b> <small>(BOM: {activeC40Seat.foamPn})</small></span></div><p className="componentDesc">{activeC40Seat.description}</p><dl className="componentDl"><div><dt>PN (Assembly)</dt><dd className="verifiedPn"><b>{activeC40Seat.pn}</b></dd></div><div><dt>Customer no.</dt><dd><span className="pendingText">To be assigned</span></dd></div><div><dt>Foam / Padding</dt><dd><b>{activeC40Seat.foamSpec}</b></dd></div><div><dt>Seat Width</dt><dd>Standard</dd></div></dl><button type="button" className="addButton" onClick={() => addPart(4)}>
                            Add to request
                          </button></div></div></div></article>;
    };
    const renderC10InsertCard = () => {
      const activeC10Backrest = C10_BACKREST_VARIANTS[c10BackrestVariant];
      const activeC10Seat = C10_SEAT_VARIANTS[c10SeatVariant];
      return <article className="systemCard" key="c10-insert-system"><div className="systemCardHeader"><div><span className="systemTag">CITOS 10 · MOLDED INSERT SYSTEM (UNPADDED)</span><h3>Citos 10 Insert Components</h3><p>Durable molded ergonomic polymer backrest and seat insert set.</p></div><span className="systemBadge">2 Parts</span></div><div className="systemComponentsGrid">{
        /* C10 Backrest with Image & Variant Selector */
      }<div className="componentRow" key="c10-backrest"><div className="componentVisual"><img
        src={activeC10Backrest.image}
        alt={activeC10Backrest.description}
        className="componentRenderImg"
      /><span className="componentTypeBadge">Backrest Insert</span></div><div className="componentContent"><h4>Citos 10 Backrest Insert</h4><div className="componentSelector" aria-label="Citos 10 color and standard selection"><button
        type="button"
        className={c10BackrestVariant === "Dark Gray" ? "active" : ""}
        onClick={() => setC10BackrestVariant("Dark Gray")}
      ><i className="swatch darkGray" />
                              Dark Grey (Doc 90)
                            </button><button
        type="button"
        className={c10BackrestVariant === "Blue" ? "active" : ""}
        onClick={() => setC10BackrestVariant("Blue")}
      ><i className="swatch" style={{ background: "#2b547e" }} />
                              Blue (FMVSS 302)
                            </button></div><span className="componentTrimSpec">{activeC10Backrest.colorCode} · {activeC10Backrest.standard}</span><p className="componentDesc">{activeC10Backrest.description}</p><dl className="componentDl"><div><dt>PN</dt><dd className="verifiedPn"><b>{activeC10Backrest.pn}</b></dd></div><div><dt>Customer no.</dt><dd><span className="pendingText">To be assigned</span></dd></div><div><dt>BOM Config</dt><dd>{activeC10Backrest.bomRef}</dd></div></dl><button type="button" className="addButton" onClick={() => addPart(5)}>
                            Add to request
                          </button></div></div>{
        /* C10 Seat Insert with Image & Variant Selector */
      }<div className="componentRow" key="c10-seat"><div className="componentVisual"><img
        src={activeC10Seat.image}
        alt={activeC10Seat.description}
        className="componentRenderImg"
      /><span className="componentTypeBadge">Seat Insert</span></div><div className="componentContent"><h4>Citos 10 Seat Insert</h4><div className="componentSelector" aria-label="Citos 10 seat color and standard selection"><button
        type="button"
        className={c10SeatVariant === "Dark Gray" ? "active" : ""}
        onClick={() => setC10SeatVariant("Dark Gray")}
      ><i className="swatch darkGray" />
                              Dark Grey (Doc 90)
                            </button><button
        type="button"
        className={c10SeatVariant === "Blue" ? "active" : ""}
        onClick={() => setC10SeatVariant("Blue")}
      ><i className="swatch" style={{ background: "#2b547e" }} />
                              Blue (FMVSS 302)
                            </button></div><span className="componentTrimSpec">{activeC10Seat.colorCode} · {activeC10Seat.standard}</span><p className="componentDesc">{activeC10Seat.description}</p><dl className="componentDl"><div><dt>PN</dt><dd className="verifiedPn"><b>{activeC10Seat.pn}</b></dd></div><div><dt>Customer no.</dt><dd><span className="pendingText">To be assigned</span></dd></div><div><dt>BOM Config</dt><dd>{activeC10Seat.bomRef}</dd></div></dl><button type="button" className="addButton" onClick={() => addPart(6)}>
                            Add to request
                          </button></div></div></div></article>;
    };
    if (isAllPartsView) {
      const shellParts = visibleParts.filter((p) => p.id === 1 || p.id === 2);
      const remainingParts = visibleParts.filter((p) => p.id >= 7);
      return <>{shellParts.map((part) => renderPartCard(part))}{renderC40UpholsteryCard()}{renderC10InsertCard()}<div className="productGridAccessories">{remainingParts.map((part) => renderPartCard(part))}</div></>;
    }
    if (group === "Upholstery" && !query.trim()) {
      return renderC40UpholsteryCard();
    }
    if (group === "Inserts" && !query.trim()) {
      return renderC10InsertCard();
    }
    if (group === "Spacer & GR Caps" || group === "Accessories" || group === "Small parts") {
      return <div className="productGridAccessories">{visibleParts.map((part) => renderPartCard(part))}</div>;
    }
    return visibleParts.map((part) => renderPartCard(part));
  })()}{visibleParts.length === 0 && <p className="noResults">No matching parts found.</p>}</div></div></section><section className="supportStrip"><div><p className="eyebrow">NEED HELP IDENTIFYING A PART?</p><h2>Send us your seat details.</h2></div><a href="mailto:office@kielna.com">Contact Kiel Americas</a></section></>}<footer><img src="/kiel-logo.png" alt="Kiel Seating Solutions" /><p>Genuine spare parts requests for Kiel Americas customers.</p></footer>{cartOpen && <div className="drawerLayer" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && setCartOpen(false)}><aside className="cartDrawer" role="dialog" aria-modal="true" aria-label="Parts request cart"><div className="drawerHeader"><div><p className="eyebrow">KIEL AMERICAS</p><h2>Spare Parts Request</h2></div><button className="closeButton" onClick={() => setCartOpen(false)} aria-label="Close cart">×</button></div>{cartItemsList.length === 0 ? <div className="emptyCart"><span>0</span><h3>Your request is empty</h3><p>Add spare parts from the catalog to begin.</p></div> : <div className="cartLines">{cartItemsList.map((item) => <article key={item.lineId}>{item.image ? <img className="cartShellImage" src={item.image} alt="" /> : <Placeholder compact />}<div className="cartLineInfo"><b>{item.name}</b><span className="cartLineDesc">{item.description}</span><div className="cartLineCodes"><span>PN: <b>{item.pn || "Pending verification"}</b></span>{item.configurationCode && <span>Config: <small>{item.configurationCode}</small></span>}<span>Customer no.: <b>{item.customerNumber || "To be assigned"}</b></span></div>{item.fasteners && <div className="cartSubItems"><span className="cartSubItemsTitle">Included Fasteners (Attached Sub-Assembly Kit):</span><ul className="cartSubItemsList">{item.fasteners.map((f) => <li key={f.pn}><span className="subItemTree">└─</span><span className="subItemPn">{f.pn}</span><span className="subItemDesc">{f.description}</span><span className="subItemQty">Qty: {f.qty * item.quantity} ({f.qty}/unit)</span></li>)}</ul></div>}</div><div className="quantity"><button onClick={() => changeQuantity(item.lineId, item.quantity - 1)}>−</button><span>{item.quantity}</span><button onClick={() => changeQuantity(item.lineId, item.quantity + 1)}>+</button></div></article>)}</div>}<div className="drawerActions"><button type="button" className="printBtn" onClick={() => window.print()} disabled={!cartItemsList.length}>
                🖨️ Generate PDF Specification Sheet
              </button></div><section className="printDocument" aria-hidden="true"><header><img src="/kiel-logo.png" alt="" /><div><b>Spare Parts Request</b><span>{seatModel} Standard Seat</span></div></header><div className="printMeta"><p><b>Application:</b> {seatModel} Standard Seat</p><p><b>Document:</b> Spare Parts Specification Sheet</p><p><b>Date:</b> {(/* @__PURE__ */ new Date()).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p><p><b>Order Channel:</b> Kiel Americas Spare Parts (<a href="mailto:office@kielna.com">office@kielna.com</a>)</p></div><table><thead><tr><th>Visual</th><th>Qty</th><th>Part &amp; Specification</th><th>PN</th><th>Config Code</th><th>Customer No.</th></tr></thead><tbody>{cartItemsList.map((item) => <tr key={item.lineId}><td className="printImgCell">{item.image ? <img src={item.image} alt="" className="printThumbnail" /> : <span style={{ fontSize: "16px", color: "#94a3b8" }}>◫</span>}</td><td className="printQtyCell">{item.quantity}</td><td><div className="printItemName">{item.name}</div><div className="printDesc">{item.description}</div>{item.fasteners && <div className="printSubItemsBox"><span className="printSubItemsHeader">
                              ↳ Attached Mounting Fasteners (Sub-Assembly Kit):
                            </span><div className="printSubItemsGrid">{item.fasteners.map((f) => <div key={f.pn} className="printSubItem"><span className="subPn">{f.pn}</span><span className="subDesc">{f.description}</span><span className="subQty">Qty: {f.qty * item.quantity} ({f.qty}/unit)</span></div>)}</div></div>}</td><td><b>{item.pn || "Pending verification"}</b></td><td><small>{item.configurationCode || "\u2014"}</small></td><td>{item.customerNumber || "To be assigned"}</td></tr>)}</tbody></table><p className="printNote">This request document requires verification and confirmation by Kiel Americas before ordering.</p></section></aside></div>}{
    /* =========================================================================
       FASTENER KIT POPUP MODAL (AÇILIR PENCERE)
       ========================================================================= */
  }{fastenerModalPartId !== null && (() => {
    const kit = getFastenerKitMeta(fastenerModalPartId);
    if (!kit) return null;
    const isIncluded = !!includeHardware[fastenerModalPartId];
    return <div
      className="modalOverlay"
      role="presentation"
      onMouseDown={(e) => e.target === e.currentTarget && setFastenerModalPartId(null)}
    ><div className="modalCard" role="dialog" aria-modal="true" aria-label="Mounting Fasteners Kit"><div className="modalHeader"><div><span className="modalEyebrow">CERTIFIED ASSEMBLY FASTENERS</span><h3>{kit.title}</h3><p className="modalSubtitle">{kit.parentName}</p></div><button
      type="button"
      className="modalCloseBtn"
      onClick={() => setFastenerModalPartId(null)}
      aria-label="Close modal"
    >
                  ✕
                </button></div><div className="modalBody"><div className={`modalToggleBox ${isIncluded ? "active" : ""}`}><label className="modalCheckboxLabel"><input
      type="checkbox"
      checked={isIncluded}
      onChange={() => toggleHardware(fastenerModalPartId)}
    /><span className="modalCustomCheck">{isIncluded && "\u2713"}</span><div className="modalCheckboxText"><strong>Include Complete Fastener Kit with this item</strong><span>Automatically bundles official mounting hardware when component is added to request cart.</span></div></label></div><div className="modalSectionHeading"><b>BOM Item Breakdown (Per Component)</b><span>Order complete kit above or click &ldquo;+ Order loose&rdquo; for individual loose replacement hardware:</span></div><div className="modalFastenersTableWrapper"><table className="modalFastenersTable"><thead><tr><th>Part No (PN)</th><th>Description &amp; Specification</th><th>Qty / Unit</th><th>Action</th></tr></thead><tbody>{kit.items.map((item) => <tr key={item.pn}><td className="pnCell"><b>{item.pn}</b></td><td><div className="fastenerTitle">{item.description}</div>{item.spec && <small className="fastenerSpec">Spec: {item.spec}</small>}</td><td className="qtyCell"><span className="qtyBadge">{item.qty} pcs</span></td><td className="actionCell"><button
      type="button"
      className="orderLooseBtn"
      onClick={() => {
        addHardwareItem(item.id, item.pn, item.description, item.qty);
        setFastenerModalPartId(null);
      }}
      title={`Order ${item.description} (${item.pn}) individually`}
    >
                              + Order loose ({item.qty}x)
                            </button></td></tr>)}</tbody></table></div>{kit.note && <div className="modalNote"><b>ℹ️ Engineering Note:</b><p>{kit.note}</p></div>}</div><div className="modalFooter"><button
      type="button"
      className="modalSecondaryBtn"
      onClick={() => setFastenerModalPartId(null)}
    >
                  Close
                </button><button
      type="button"
      className="modalPrimaryBtn"
      onClick={() => {
        if (!isIncluded) toggleHardware(fastenerModalPartId);
        setFastenerModalPartId(null);
      }}
    >{isIncluded ? "Done" : "Include Kit & Close"}</button></div></div></div>;
  })()}{
    /* =========================================================================
       USB TECHNICAL & ELECTRICAL SPECIFICATION MODAL (AÇILIR PENCERE)
       ========================================================================= */
  }{usbSpecOpen && <div
    className="modalOverlay"
    role="presentation"
    onMouseDown={(e) => e.target === e.currentTarget && setUsbSpecOpen(false)}
  ><div className="modalCard modalWide" role="dialog" aria-modal="true" aria-label="USB Technical Specification"><div className="modalHeader"><div><span className="modalEyebrow">PASSENGER SEATING ELECTRICS · SPECIFICATION SHEET</span><h3>Dual USB Type-A / Type-C Charging Module</h3><p className="modalSubtitle">Official Kiel PN: 522898 · Integrated 60mm Cable Harness</p></div><button
    type="button"
    className="modalCloseBtn"
    onClick={() => setUsbSpecOpen(false)}
    aria-label="Close modal"
  >
                ✕
              </button></div><div className="modalBody"><div className="usbSpecGrid"><div className="usbSpecDrawingBox"><div className="drawingHeader"><b>Installation Drawing &amp; Connector Callout</b><span>Integrated 60mm lead with Molex termination</span></div><div className="drawingImgWrap"><img
    src="/renders/accessories/usb-diagram.png"
    alt="USB Module Connector Drawing - MOLEX 3901-3023"
  /></div><div className="connectorHighlight"><div className="connectorRow"><span className="connLabel">Power Connector on Unit:</span><strong className="connValue">MOLEX 3901-3023</strong></div><div className="connectorRow"><span className="connLabel">Mating Connector (Vehicle side):</span><span className="connValue">MOLEX 3901-2020 (not included)</span></div></div></div><div className="usbSpecTableBox"><div className="tableHeader"><b>Electrical &amp; Physical Specifications</b><span>Kiel Transit Seating Standard</span></div><table className="specDataTable"><tbody><tr><th>Input Voltage</th><td>9 – 32 V (DC)</td></tr><tr><th>Output 1 (USB-A)</th><td><b>QC 3.0</b> · 3.7 – 12 V<br /><span>5V/2A; 9V/2.3A; 12V/2.25A</span><br /><strong>Max Power: 27 W</strong></td></tr><tr><th>Output 2 (USB-C)</th><td><b>PD (Power Delivery)</b> · 5 – 20 V (100mV)<br /><span>5V/2.3A; 9V/2.3A; 12V/2.23A; 15V/3A; 20V/2.5A</span><br /><strong>Max Power: 50 W</strong></td></tr><tr className="highlightRow"><th>Total Max Power</th><td><b className="powerTag">77 W Total Output</b></td></tr><tr><th>LED Status Indication</th><td><div className="ledSpecList"><div><span className="ledDot white" /> White: Backlight around connectors</div><div><span className="ledDot green" /> Green: Standby mode</div><div><span className="ledDot red" /> Red: Active charging</div></div></td></tr><tr><th>Standby Power</th><td>&lt; 100 mA</td></tr><tr><th>Efficiency</th><td>90% max.</td></tr><tr><th>Working Temperature</th><td>-20°C to +60°C</td></tr><tr><th>Housing Material</th><td>Flame-retardant transit-grade plastic</td></tr><tr><th>Circuit Protection</th><td>Overvoltage / Overcurrent / Low voltage / Reverse connection / Short circuit</td></tr></tbody></table></div></div><div className="modalNote" style={{ marginTop: "18px" }}><b>ℹ️ Installation &amp; Bracket Notice:</b><p>
                  This item supplies the complete USB module enclosure and electronics with a 60mm pigtail harness and MOLEX 3901-3023 connector. Sheet metal mounting bracket plates (sac malzemeler) for attaching to standard Citos seat frames will be selectable as an independent installation accessory card.
                </p></div></div><div className="modalFooter"><button
    type="button"
    className="modalSecondaryBtn"
    onClick={() => setUsbSpecOpen(false)}
  >
                Close Specification
              </button><button
    type="button"
    className="modalPrimaryBtn"
    onClick={() => {
      addPart(10);
      setUsbSpecOpen(false);
    }}
  >
                Add USB Module to Request Cart (+1)
              </button></div></div></div>}</main>;
}
export {
  ALL_HARDWARE_ITEMS,
  ARMREST_VARIANTS,
  C10_BACKREST_VARIANTS,
  C10_SEAT_VARIANTS,
  C40_BACKREST_VARIANTS,
  C40_SEAT_VARIANTS,
  CITOS_10_INSERT_REFERENCE_TABLES,
  CITOS_40_FOAM_REFERENCE_TABLE,
  GRABRAIL_CAP_VARIANTS,
  RUBBER_FASTENERS_BOM,
  SHELL_FASTENERS_BOM,
  SPACER_FASTENERS_BOM,
  SPACER_VARIANTS,
  STANCHION_CUP_VARIANTS,
  T_PEDESTAL_CONFIGS,
  USB_FASTENERS_BOM,
  Home as default
};
